/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * My Emissions API
 * We calculate food carbon footprints
 * OpenAPI spec version: 1.0.0 (v1)
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  AccountCompleteSignup,
  AccountCreate,
  AccountCreateResponse,
  AccountResponse,
  AccountVerifyEmail,
  AppAccountSearchOrganisationsListParams,
  AppAvailablePackagingListParams,
  AppAvailableProcessingListParams,
  AppAvailableTransportListParams,
  AppBaseFoodsListParams,
  AppIngredientPickerListParams,
  AppProductsListParams,
  AppShareQueryRetrieveParams,
  AssessRequest,
  AssessResponse,
  AvailableIngredients,
  AvailablePackaging,
  AvailableProcessing,
  AvailableTransport,
  CollectionCreateUpdate,
  CollectionDetail,
  CollectionList,
  Home,
  IngredientInsightsList,
  IngredientPickerItem,
  JourneyGroupCreate,
  JourneyGroupList,
  JourneyGroupUpdate,
  Login,
  MyPasswordReset,
  OrganisationSummary,
  OrganizationUpdate,
  PackagingType,
  PackagingTypeCreate,
  PackagingTypeFileFinish,
  PackagingTypeFileRetrieve,
  PackagingTypeUpdate,
  PaginatedOrganisationSummaryList,
  PaginatedProductListList,
  PasswordChange,
  PasswordResetConfirm,
  PatchedCollectionCreateUpdate,
  PatchedJourneyGroupUpdate,
  PatchedOrganizationUpdate,
  PatchedProcessingTypeUpdate,
  PatchedProductCreateUpdate,
  ProcessingTypeCreate,
  ProcessingTypeFileFinish,
  ProcessingTypeFileRetrieve,
  ProcessingTypeList,
  ProcessingTypeUpdate,
  ProductCreateUpdate,
  ProductDetail,
  ProductResult,
  RemoteAccount,
  Report,
  ReportOrganizationFoodDetail,
  ReportProductDetail,
  SharedLinkResponse,
  SharedLinkVerifyResponse,
  SwitchOrganisationRequest,
  TokenRefresh,
  TokenVerify,
  TransportTypeFileFinish,
  TransportTypeFileRetrieve,
  Unit
} from '../../types'
import { apiClient } from '../../client';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;



type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * Create or retrieve the user's account.
 */
export const appAccountRetrieve = (
    
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<AccountResponse>(
      {url: `/app/account/`, method: 'GET', signal
    },
      options);
    }
  

export const getAppAccountRetrieveQueryKey = () => {
    return [`/app/account/`] as const;
    }

    
export const getAppAccountRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof appAccountRetrieve>>, TError = unknown>( options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appAccountRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppAccountRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appAccountRetrieve>>> = ({ signal }) => appAccountRetrieve(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof appAccountRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AppAccountRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof appAccountRetrieve>>>
export type AppAccountRetrieveInfiniteQueryError = unknown

export const useAppAccountRetrieveInfinite = <TData = Awaited<ReturnType<typeof appAccountRetrieve>>, TError = unknown>(
  options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appAccountRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppAccountRetrieveInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAppAccountRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof appAccountRetrieve>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appAccountRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppAccountRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appAccountRetrieve>>> = ({ signal }) => appAccountRetrieve(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appAccountRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AppAccountRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof appAccountRetrieve>>>
export type AppAccountRetrieveQueryError = unknown

export const useAppAccountRetrieve = <TData = Awaited<ReturnType<typeof appAccountRetrieve>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appAccountRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppAccountRetrieveQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Create or retrieve the user's account.
 */
export const appAccountCreate = (
    accountCreate: AccountCreate,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<AccountCreateResponse>(
      {url: `/app/account/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: accountCreate
    },
      options);
    }
  


export const getAppAccountCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appAccountCreate>>, TError,{data: AccountCreate}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof appAccountCreate>>, TError,{data: AccountCreate}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appAccountCreate>>, {data: AccountCreate}> = (props) => {
          const {data} = props ?? {};

          return  appAccountCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AppAccountCreateMutationResult = NonNullable<Awaited<ReturnType<typeof appAccountCreate>>>
    export type AppAccountCreateMutationBody = AccountCreate
    export type AppAccountCreateMutationError = unknown

    export const useAppAccountCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appAccountCreate>>, TError,{data: AccountCreate}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof appAccountCreate>>,
        TError,
        {data: AccountCreate},
        TContext
      > => {

      const mutationOptions = getAppAccountCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Complete the user signup
 */
export const appAccountCompleteSignupCreate = (
    accountCompleteSignup: AccountCompleteSignup,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<AccountCompleteSignup>(
      {url: `/app/account/complete-signup`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: accountCompleteSignup
    },
      options);
    }
  


export const getAppAccountCompleteSignupCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appAccountCompleteSignupCreate>>, TError,{data: AccountCompleteSignup}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof appAccountCompleteSignupCreate>>, TError,{data: AccountCompleteSignup}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appAccountCompleteSignupCreate>>, {data: AccountCompleteSignup}> = (props) => {
          const {data} = props ?? {};

          return  appAccountCompleteSignupCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AppAccountCompleteSignupCreateMutationResult = NonNullable<Awaited<ReturnType<typeof appAccountCompleteSignupCreate>>>
    export type AppAccountCompleteSignupCreateMutationBody = AccountCompleteSignup
    export type AppAccountCompleteSignupCreateMutationError = unknown

    export const useAppAccountCompleteSignupCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appAccountCompleteSignupCreate>>, TError,{data: AccountCompleteSignup}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof appAccountCompleteSignupCreate>>,
        TError,
        {data: AccountCompleteSignup},
        TContext
      > => {

      const mutationOptions = getAppAccountCompleteSignupCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const appAccountE2eSeedUsersCreate = (
    
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<void>(
      {url: `/app/account/e2e/seed-users/`, method: 'POST'
    },
      options);
    }
  


export const getAppAccountE2eSeedUsersCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appAccountE2eSeedUsersCreate>>, TError,void, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof appAccountE2eSeedUsersCreate>>, TError,void, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appAccountE2eSeedUsersCreate>>, void> = () => {
          

          return  appAccountE2eSeedUsersCreate(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AppAccountE2eSeedUsersCreateMutationResult = NonNullable<Awaited<ReturnType<typeof appAccountE2eSeedUsersCreate>>>
    
    export type AppAccountE2eSeedUsersCreateMutationError = unknown

    export const useAppAccountE2eSeedUsersCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appAccountE2eSeedUsersCreate>>, TError,void, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof appAccountE2eSeedUsersCreate>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getAppAccountE2eSeedUsersCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const appAccountE2eSeedUsersDeleteDestroy = (
    
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<void>(
      {url: `/app/account/e2e/seed-users/delete/`, method: 'DELETE'
    },
      options);
    }
  


export const getAppAccountE2eSeedUsersDeleteDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appAccountE2eSeedUsersDeleteDestroy>>, TError,void, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof appAccountE2eSeedUsersDeleteDestroy>>, TError,void, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appAccountE2eSeedUsersDeleteDestroy>>, void> = () => {
          

          return  appAccountE2eSeedUsersDeleteDestroy(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AppAccountE2eSeedUsersDeleteDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof appAccountE2eSeedUsersDeleteDestroy>>>
    
    export type AppAccountE2eSeedUsersDeleteDestroyMutationError = unknown

    export const useAppAccountE2eSeedUsersDeleteDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appAccountE2eSeedUsersDeleteDestroy>>, TError,void, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof appAccountE2eSeedUsersDeleteDestroy>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getAppAccountE2eSeedUsersDeleteDestroyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Update specific organization fields.
Only allows updating reporting_year_start_month and reporting_year_start_day.
 */
export const appAccountOrganisationPartialUpdate = (
    patchedOrganizationUpdate: PatchedOrganizationUpdate,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<OrganizationUpdate>(
      {url: `/app/account/organisation`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedOrganizationUpdate
    },
      options);
    }
  


export const getAppAccountOrganisationPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appAccountOrganisationPartialUpdate>>, TError,{data: PatchedOrganizationUpdate}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof appAccountOrganisationPartialUpdate>>, TError,{data: PatchedOrganizationUpdate}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appAccountOrganisationPartialUpdate>>, {data: PatchedOrganizationUpdate}> = (props) => {
          const {data} = props ?? {};

          return  appAccountOrganisationPartialUpdate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AppAccountOrganisationPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof appAccountOrganisationPartialUpdate>>>
    export type AppAccountOrganisationPartialUpdateMutationBody = PatchedOrganizationUpdate
    export type AppAccountOrganisationPartialUpdateMutationError = unknown

    export const useAppAccountOrganisationPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appAccountOrganisationPartialUpdate>>, TError,{data: PatchedOrganizationUpdate}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof appAccountOrganisationPartialUpdate>>,
        TError,
        {data: PatchedOrganizationUpdate},
        TContext
      > => {

      const mutationOptions = getAppAccountOrganisationPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Base view for remote API views.
 */
export const appAccountRemoteRetrieve = (
    
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<RemoteAccount>(
      {url: `/app/account/remote/`, method: 'GET', signal
    },
      options);
    }
  

export const getAppAccountRemoteRetrieveQueryKey = () => {
    return [`/app/account/remote/`] as const;
    }

    
export const getAppAccountRemoteRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof appAccountRemoteRetrieve>>, TError = unknown>( options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appAccountRemoteRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppAccountRemoteRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appAccountRemoteRetrieve>>> = ({ signal }) => appAccountRemoteRetrieve(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof appAccountRemoteRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AppAccountRemoteRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof appAccountRemoteRetrieve>>>
export type AppAccountRemoteRetrieveInfiniteQueryError = unknown

export const useAppAccountRemoteRetrieveInfinite = <TData = Awaited<ReturnType<typeof appAccountRemoteRetrieve>>, TError = unknown>(
  options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appAccountRemoteRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppAccountRemoteRetrieveInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAppAccountRemoteRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof appAccountRemoteRetrieve>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appAccountRemoteRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppAccountRemoteRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appAccountRemoteRetrieve>>> = ({ signal }) => appAccountRemoteRetrieve(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appAccountRemoteRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AppAccountRemoteRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof appAccountRemoteRetrieve>>>
export type AppAccountRemoteRetrieveQueryError = unknown

export const useAppAccountRemoteRetrieve = <TData = Awaited<ReturnType<typeof appAccountRemoteRetrieve>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appAccountRemoteRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppAccountRemoteRetrieveQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Resend the email verification email.
 */
export const appAccountResendEmailVerificationCreate = (
    
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<void>(
      {url: `/app/account/resend-email-verification`, method: 'POST'
    },
      options);
    }
  


export const getAppAccountResendEmailVerificationCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appAccountResendEmailVerificationCreate>>, TError,void, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof appAccountResendEmailVerificationCreate>>, TError,void, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appAccountResendEmailVerificationCreate>>, void> = () => {
          

          return  appAccountResendEmailVerificationCreate(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AppAccountResendEmailVerificationCreateMutationResult = NonNullable<Awaited<ReturnType<typeof appAccountResendEmailVerificationCreate>>>
    
    export type AppAccountResendEmailVerificationCreateMutationError = unknown

    export const useAppAccountResendEmailVerificationCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appAccountResendEmailVerificationCreate>>, TError,void, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof appAccountResendEmailVerificationCreate>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getAppAccountResendEmailVerificationCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Search organisations by name, for staff switching into a client account.

Covers `Organization.staff_searchable()`, not the caller's memberships.

Returns nothing until at least two characters are typed, which keeps the
switcher empty at rest so client names are not on screen when a staff user
shares their screen.
 */
export const appAccountSearchOrganisationsList = (
    params?: AppAccountSearchOrganisationsListParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<PaginatedOrganisationSummaryList>(
      {url: `/app/account/search-organisations`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getAppAccountSearchOrganisationsListQueryKey = (params?: AppAccountSearchOrganisationsListParams,) => {
    return [`/app/account/search-organisations`, ...(params ? [params]: [])] as const;
    }

    
export const getAppAccountSearchOrganisationsListInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof appAccountSearchOrganisationsList>>, TError = unknown>(params?: AppAccountSearchOrganisationsListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appAccountSearchOrganisationsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppAccountSearchOrganisationsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appAccountSearchOrganisationsList>>> = ({ signal, pageParam }) => appAccountSearchOrganisationsList({...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof appAccountSearchOrganisationsList>>, TError, TData> & { queryKey: QueryKey }
}

export type AppAccountSearchOrganisationsListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof appAccountSearchOrganisationsList>>>
export type AppAccountSearchOrganisationsListInfiniteQueryError = unknown

export const useAppAccountSearchOrganisationsListInfinite = <TData = Awaited<ReturnType<typeof appAccountSearchOrganisationsList>>, TError = unknown>(
 params?: AppAccountSearchOrganisationsListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appAccountSearchOrganisationsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppAccountSearchOrganisationsListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAppAccountSearchOrganisationsListQueryOptions = <TData = Awaited<ReturnType<typeof appAccountSearchOrganisationsList>>, TError = unknown>(params?: AppAccountSearchOrganisationsListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appAccountSearchOrganisationsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppAccountSearchOrganisationsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appAccountSearchOrganisationsList>>> = ({ signal }) => appAccountSearchOrganisationsList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appAccountSearchOrganisationsList>>, TError, TData> & { queryKey: QueryKey }
}

export type AppAccountSearchOrganisationsListQueryResult = NonNullable<Awaited<ReturnType<typeof appAccountSearchOrganisationsList>>>
export type AppAccountSearchOrganisationsListQueryError = unknown

export const useAppAccountSearchOrganisationsList = <TData = Awaited<ReturnType<typeof appAccountSearchOrganisationsList>>, TError = unknown>(
 params?: AppAccountSearchOrganisationsListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appAccountSearchOrganisationsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppAccountSearchOrganisationsListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Switch the authenticated user's active organisation.

Customers may only switch into an organisation they hold a membership for.
Staff may switch into any organisation. Either way this only moves
`Profile.organization`; memberships are never written.
 */
export const appAccountSwitchOrganisationCreate = (
    switchOrganisationRequest: SwitchOrganisationRequest,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<OrganisationSummary>(
      {url: `/app/account/switch-organisation`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: switchOrganisationRequest
    },
      options);
    }
  


export const getAppAccountSwitchOrganisationCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appAccountSwitchOrganisationCreate>>, TError,{data: SwitchOrganisationRequest}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof appAccountSwitchOrganisationCreate>>, TError,{data: SwitchOrganisationRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appAccountSwitchOrganisationCreate>>, {data: SwitchOrganisationRequest}> = (props) => {
          const {data} = props ?? {};

          return  appAccountSwitchOrganisationCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AppAccountSwitchOrganisationCreateMutationResult = NonNullable<Awaited<ReturnType<typeof appAccountSwitchOrganisationCreate>>>
    export type AppAccountSwitchOrganisationCreateMutationBody = SwitchOrganisationRequest
    export type AppAccountSwitchOrganisationCreateMutationError = unknown

    export const useAppAccountSwitchOrganisationCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appAccountSwitchOrganisationCreate>>, TError,{data: SwitchOrganisationRequest}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof appAccountSwitchOrganisationCreate>>,
        TError,
        {data: SwitchOrganisationRequest},
        TContext
      > => {

      const mutationOptions = getAppAccountSwitchOrganisationCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Verify the user's email.
 */
export const appAccountVerifyEmailCreate = (
    accountVerifyEmail: AccountVerifyEmail,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<unknown>(
      {url: `/app/account/verify-email`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: accountVerifyEmail
    },
      options);
    }
  


export const getAppAccountVerifyEmailCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appAccountVerifyEmailCreate>>, TError,{data: AccountVerifyEmail}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof appAccountVerifyEmailCreate>>, TError,{data: AccountVerifyEmail}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appAccountVerifyEmailCreate>>, {data: AccountVerifyEmail}> = (props) => {
          const {data} = props ?? {};

          return  appAccountVerifyEmailCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AppAccountVerifyEmailCreateMutationResult = NonNullable<Awaited<ReturnType<typeof appAccountVerifyEmailCreate>>>
    export type AppAccountVerifyEmailCreateMutationBody = AccountVerifyEmail
    export type AppAccountVerifyEmailCreateMutationError = unknown

    export const useAppAccountVerifyEmailCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appAccountVerifyEmailCreate>>, TError,{data: AccountVerifyEmail}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof appAccountVerifyEmailCreate>>,
        TError,
        {data: AccountVerifyEmail},
        TContext
      > => {

      const mutationOptions = getAppAccountVerifyEmailCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const appAvailablePackagingList = (
    params?: AppAvailablePackagingListParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<AvailablePackaging[]>(
      {url: `/app/available_packaging/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getAppAvailablePackagingListQueryKey = (params?: AppAvailablePackagingListParams,) => {
    return [`/app/available_packaging/`, ...(params ? [params]: [])] as const;
    }

    
export const getAppAvailablePackagingListInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof appAvailablePackagingList>>, TError = unknown>(params?: AppAvailablePackagingListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appAvailablePackagingList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppAvailablePackagingListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appAvailablePackagingList>>> = ({ signal, pageParam }) => appAvailablePackagingList({...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof appAvailablePackagingList>>, TError, TData> & { queryKey: QueryKey }
}

export type AppAvailablePackagingListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof appAvailablePackagingList>>>
export type AppAvailablePackagingListInfiniteQueryError = unknown

export const useAppAvailablePackagingListInfinite = <TData = Awaited<ReturnType<typeof appAvailablePackagingList>>, TError = unknown>(
 params?: AppAvailablePackagingListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appAvailablePackagingList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppAvailablePackagingListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAppAvailablePackagingListQueryOptions = <TData = Awaited<ReturnType<typeof appAvailablePackagingList>>, TError = unknown>(params?: AppAvailablePackagingListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appAvailablePackagingList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppAvailablePackagingListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appAvailablePackagingList>>> = ({ signal }) => appAvailablePackagingList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appAvailablePackagingList>>, TError, TData> & { queryKey: QueryKey }
}

export type AppAvailablePackagingListQueryResult = NonNullable<Awaited<ReturnType<typeof appAvailablePackagingList>>>
export type AppAvailablePackagingListQueryError = unknown

export const useAppAvailablePackagingList = <TData = Awaited<ReturnType<typeof appAvailablePackagingList>>, TError = unknown>(
 params?: AppAvailablePackagingListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appAvailablePackagingList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppAvailablePackagingListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const appAvailableProcessingList = (
    params?: AppAvailableProcessingListParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<AvailableProcessing[]>(
      {url: `/app/available_processing/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getAppAvailableProcessingListQueryKey = (params?: AppAvailableProcessingListParams,) => {
    return [`/app/available_processing/`, ...(params ? [params]: [])] as const;
    }

    
export const getAppAvailableProcessingListInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof appAvailableProcessingList>>, TError = unknown>(params?: AppAvailableProcessingListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appAvailableProcessingList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppAvailableProcessingListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appAvailableProcessingList>>> = ({ signal, pageParam }) => appAvailableProcessingList({...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof appAvailableProcessingList>>, TError, TData> & { queryKey: QueryKey }
}

export type AppAvailableProcessingListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof appAvailableProcessingList>>>
export type AppAvailableProcessingListInfiniteQueryError = unknown

export const useAppAvailableProcessingListInfinite = <TData = Awaited<ReturnType<typeof appAvailableProcessingList>>, TError = unknown>(
 params?: AppAvailableProcessingListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appAvailableProcessingList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppAvailableProcessingListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAppAvailableProcessingListQueryOptions = <TData = Awaited<ReturnType<typeof appAvailableProcessingList>>, TError = unknown>(params?: AppAvailableProcessingListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appAvailableProcessingList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppAvailableProcessingListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appAvailableProcessingList>>> = ({ signal }) => appAvailableProcessingList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appAvailableProcessingList>>, TError, TData> & { queryKey: QueryKey }
}

export type AppAvailableProcessingListQueryResult = NonNullable<Awaited<ReturnType<typeof appAvailableProcessingList>>>
export type AppAvailableProcessingListQueryError = unknown

export const useAppAvailableProcessingList = <TData = Awaited<ReturnType<typeof appAvailableProcessingList>>, TError = unknown>(
 params?: AppAvailableProcessingListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appAvailableProcessingList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppAvailableProcessingListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const appAvailableTransportList = (
    params?: AppAvailableTransportListParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<AvailableTransport[]>(
      {url: `/app/available_transport/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getAppAvailableTransportListQueryKey = (params?: AppAvailableTransportListParams,) => {
    return [`/app/available_transport/`, ...(params ? [params]: [])] as const;
    }

    
export const getAppAvailableTransportListInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof appAvailableTransportList>>, TError = unknown>(params?: AppAvailableTransportListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appAvailableTransportList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppAvailableTransportListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appAvailableTransportList>>> = ({ signal, pageParam }) => appAvailableTransportList({...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof appAvailableTransportList>>, TError, TData> & { queryKey: QueryKey }
}

export type AppAvailableTransportListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof appAvailableTransportList>>>
export type AppAvailableTransportListInfiniteQueryError = unknown

export const useAppAvailableTransportListInfinite = <TData = Awaited<ReturnType<typeof appAvailableTransportList>>, TError = unknown>(
 params?: AppAvailableTransportListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appAvailableTransportList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppAvailableTransportListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAppAvailableTransportListQueryOptions = <TData = Awaited<ReturnType<typeof appAvailableTransportList>>, TError = unknown>(params?: AppAvailableTransportListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appAvailableTransportList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppAvailableTransportListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appAvailableTransportList>>> = ({ signal }) => appAvailableTransportList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appAvailableTransportList>>, TError, TData> & { queryKey: QueryKey }
}

export type AppAvailableTransportListQueryResult = NonNullable<Awaited<ReturnType<typeof appAvailableTransportList>>>
export type AppAvailableTransportListQueryError = unknown

export const useAppAvailableTransportList = <TData = Awaited<ReturnType<typeof appAvailableTransportList>>, TError = unknown>(
 params?: AppAvailableTransportListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appAvailableTransportList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppAvailableTransportListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const appBaseFoodsList = (
    params?: AppBaseFoodsListParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<AvailableIngredients[]>(
      {url: `/app/base-foods/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getAppBaseFoodsListQueryKey = (params?: AppBaseFoodsListParams,) => {
    return [`/app/base-foods/`, ...(params ? [params]: [])] as const;
    }

    
export const getAppBaseFoodsListInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof appBaseFoodsList>>, TError = unknown>(params?: AppBaseFoodsListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appBaseFoodsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppBaseFoodsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appBaseFoodsList>>> = ({ signal, pageParam }) => appBaseFoodsList({...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof appBaseFoodsList>>, TError, TData> & { queryKey: QueryKey }
}

export type AppBaseFoodsListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof appBaseFoodsList>>>
export type AppBaseFoodsListInfiniteQueryError = unknown

export const useAppBaseFoodsListInfinite = <TData = Awaited<ReturnType<typeof appBaseFoodsList>>, TError = unknown>(
 params?: AppBaseFoodsListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appBaseFoodsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppBaseFoodsListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAppBaseFoodsListQueryOptions = <TData = Awaited<ReturnType<typeof appBaseFoodsList>>, TError = unknown>(params?: AppBaseFoodsListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appBaseFoodsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppBaseFoodsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appBaseFoodsList>>> = ({ signal }) => appBaseFoodsList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appBaseFoodsList>>, TError, TData> & { queryKey: QueryKey }
}

export type AppBaseFoodsListQueryResult = NonNullable<Awaited<ReturnType<typeof appBaseFoodsList>>>
export type AppBaseFoodsListQueryError = unknown

export const useAppBaseFoodsList = <TData = Awaited<ReturnType<typeof appBaseFoodsList>>, TError = unknown>(
 params?: AppBaseFoodsListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appBaseFoodsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppBaseFoodsListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Handles the basic setup for all API views. Includes parser and permission classes, defaults to
JWT authentication and has a get_organization helper method.
 */
export const appCollectionsList = (
    
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<CollectionList[]>(
      {url: `/app/collections/`, method: 'GET', signal
    },
      options);
    }
  

export const getAppCollectionsListQueryKey = () => {
    return [`/app/collections/`] as const;
    }

    
export const getAppCollectionsListInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof appCollectionsList>>, TError = unknown>( options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appCollectionsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppCollectionsListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appCollectionsList>>> = ({ signal }) => appCollectionsList(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof appCollectionsList>>, TError, TData> & { queryKey: QueryKey }
}

export type AppCollectionsListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof appCollectionsList>>>
export type AppCollectionsListInfiniteQueryError = unknown

export const useAppCollectionsListInfinite = <TData = Awaited<ReturnType<typeof appCollectionsList>>, TError = unknown>(
  options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appCollectionsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppCollectionsListInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAppCollectionsListQueryOptions = <TData = Awaited<ReturnType<typeof appCollectionsList>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appCollectionsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppCollectionsListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appCollectionsList>>> = ({ signal }) => appCollectionsList(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appCollectionsList>>, TError, TData> & { queryKey: QueryKey }
}

export type AppCollectionsListQueryResult = NonNullable<Awaited<ReturnType<typeof appCollectionsList>>>
export type AppCollectionsListQueryError = unknown

export const useAppCollectionsList = <TData = Awaited<ReturnType<typeof appCollectionsList>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appCollectionsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppCollectionsListQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Handles the basic setup for all API views. Includes parser and permission classes, defaults to
JWT authentication and has a get_organization helper method.
 */
export const appCollectionsCreate = (
    collectionCreateUpdate: NonReadonly<CollectionCreateUpdate>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<CollectionCreateUpdate>(
      {url: `/app/collections/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: collectionCreateUpdate
    },
      options);
    }
  


export const getAppCollectionsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appCollectionsCreate>>, TError,{data: NonReadonly<CollectionCreateUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof appCollectionsCreate>>, TError,{data: NonReadonly<CollectionCreateUpdate>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appCollectionsCreate>>, {data: NonReadonly<CollectionCreateUpdate>}> = (props) => {
          const {data} = props ?? {};

          return  appCollectionsCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AppCollectionsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof appCollectionsCreate>>>
    export type AppCollectionsCreateMutationBody = NonReadonly<CollectionCreateUpdate>
    export type AppCollectionsCreateMutationError = unknown

    export const useAppCollectionsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appCollectionsCreate>>, TError,{data: NonReadonly<CollectionCreateUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof appCollectionsCreate>>,
        TError,
        {data: NonReadonly<CollectionCreateUpdate>},
        TContext
      > => {

      const mutationOptions = getAppCollectionsCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Handles the basic setup for all API views. Includes parser and permission classes, defaults to
JWT authentication and has a get_organization helper method.
 */
export const appCollectionsRetrieve = (
    collectionUuid: string,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<CollectionDetail>(
      {url: `/app/collections/${collectionUuid}/`, method: 'GET', signal
    },
      options);
    }
  

export const getAppCollectionsRetrieveQueryKey = (collectionUuid: string,) => {
    return [`/app/collections/${collectionUuid}/`] as const;
    }

    
export const getAppCollectionsRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof appCollectionsRetrieve>>, TError = unknown>(collectionUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appCollectionsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppCollectionsRetrieveQueryKey(collectionUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appCollectionsRetrieve>>> = ({ signal }) => appCollectionsRetrieve(collectionUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(collectionUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof appCollectionsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AppCollectionsRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof appCollectionsRetrieve>>>
export type AppCollectionsRetrieveInfiniteQueryError = unknown

export const useAppCollectionsRetrieveInfinite = <TData = Awaited<ReturnType<typeof appCollectionsRetrieve>>, TError = unknown>(
 collectionUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appCollectionsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppCollectionsRetrieveInfiniteQueryOptions(collectionUuid,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAppCollectionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof appCollectionsRetrieve>>, TError = unknown>(collectionUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appCollectionsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppCollectionsRetrieveQueryKey(collectionUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appCollectionsRetrieve>>> = ({ signal }) => appCollectionsRetrieve(collectionUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(collectionUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appCollectionsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AppCollectionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof appCollectionsRetrieve>>>
export type AppCollectionsRetrieveQueryError = unknown

export const useAppCollectionsRetrieve = <TData = Awaited<ReturnType<typeof appCollectionsRetrieve>>, TError = unknown>(
 collectionUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appCollectionsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppCollectionsRetrieveQueryOptions(collectionUuid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Handles the basic setup for all API views. Includes parser and permission classes, defaults to
JWT authentication and has a get_organization helper method.
 */
export const appCollectionsUpdate = (
    collectionUuid: string,
    collectionCreateUpdate: NonReadonly<CollectionCreateUpdate>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<CollectionCreateUpdate>(
      {url: `/app/collections/${collectionUuid}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: collectionCreateUpdate
    },
      options);
    }
  


export const getAppCollectionsUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appCollectionsUpdate>>, TError,{collectionUuid: string;data: NonReadonly<CollectionCreateUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof appCollectionsUpdate>>, TError,{collectionUuid: string;data: NonReadonly<CollectionCreateUpdate>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appCollectionsUpdate>>, {collectionUuid: string;data: NonReadonly<CollectionCreateUpdate>}> = (props) => {
          const {collectionUuid,data} = props ?? {};

          return  appCollectionsUpdate(collectionUuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AppCollectionsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof appCollectionsUpdate>>>
    export type AppCollectionsUpdateMutationBody = NonReadonly<CollectionCreateUpdate>
    export type AppCollectionsUpdateMutationError = unknown

    export const useAppCollectionsUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appCollectionsUpdate>>, TError,{collectionUuid: string;data: NonReadonly<CollectionCreateUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof appCollectionsUpdate>>,
        TError,
        {collectionUuid: string;data: NonReadonly<CollectionCreateUpdate>},
        TContext
      > => {

      const mutationOptions = getAppCollectionsUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Handles the basic setup for all API views. Includes parser and permission classes, defaults to
JWT authentication and has a get_organization helper method.
 */
export const appCollectionsPartialUpdate = (
    collectionUuid: string,
    patchedCollectionCreateUpdate: NonReadonly<PatchedCollectionCreateUpdate>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<CollectionCreateUpdate>(
      {url: `/app/collections/${collectionUuid}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedCollectionCreateUpdate
    },
      options);
    }
  


export const getAppCollectionsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appCollectionsPartialUpdate>>, TError,{collectionUuid: string;data: NonReadonly<PatchedCollectionCreateUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof appCollectionsPartialUpdate>>, TError,{collectionUuid: string;data: NonReadonly<PatchedCollectionCreateUpdate>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appCollectionsPartialUpdate>>, {collectionUuid: string;data: NonReadonly<PatchedCollectionCreateUpdate>}> = (props) => {
          const {collectionUuid,data} = props ?? {};

          return  appCollectionsPartialUpdate(collectionUuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AppCollectionsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof appCollectionsPartialUpdate>>>
    export type AppCollectionsPartialUpdateMutationBody = NonReadonly<PatchedCollectionCreateUpdate>
    export type AppCollectionsPartialUpdateMutationError = unknown

    export const useAppCollectionsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appCollectionsPartialUpdate>>, TError,{collectionUuid: string;data: NonReadonly<PatchedCollectionCreateUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof appCollectionsPartialUpdate>>,
        TError,
        {collectionUuid: string;data: NonReadonly<PatchedCollectionCreateUpdate>},
        TContext
      > => {

      const mutationOptions = getAppCollectionsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Handles the basic setup for all API views. Includes parser and permission classes, defaults to
JWT authentication and has a get_organization helper method.
 */
export const appCollectionsDestroy = (
    collectionUuid: string,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<void>(
      {url: `/app/collections/${collectionUuid}/`, method: 'DELETE'
    },
      options);
    }
  


export const getAppCollectionsDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appCollectionsDestroy>>, TError,{collectionUuid: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof appCollectionsDestroy>>, TError,{collectionUuid: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appCollectionsDestroy>>, {collectionUuid: string}> = (props) => {
          const {collectionUuid} = props ?? {};

          return  appCollectionsDestroy(collectionUuid,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AppCollectionsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof appCollectionsDestroy>>>
    
    export type AppCollectionsDestroyMutationError = unknown

    export const useAppCollectionsDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appCollectionsDestroy>>, TError,{collectionUuid: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof appCollectionsDestroy>>,
        TError,
        {collectionUuid: string},
        TContext
      > => {

      const mutationOptions = getAppCollectionsDestroyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Batch search for base food candidates by free-text query.

Each query is searched independently; the response preserves input order.
Used by reggie's base-food matcher agent for candidate retrieval — this
endpoint does not pick a final match.
 */
export const appFoodsBaseFoodsSearchCreate = (
    
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<void>(
      {url: `/app/foods/base-foods/search/`, method: 'POST'
    },
      options);
    }
  


export const getAppFoodsBaseFoodsSearchCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appFoodsBaseFoodsSearchCreate>>, TError,void, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof appFoodsBaseFoodsSearchCreate>>, TError,void, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appFoodsBaseFoodsSearchCreate>>, void> = () => {
          

          return  appFoodsBaseFoodsSearchCreate(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AppFoodsBaseFoodsSearchCreateMutationResult = NonNullable<Awaited<ReturnType<typeof appFoodsBaseFoodsSearchCreate>>>
    
    export type AppFoodsBaseFoodsSearchCreateMutationError = unknown

    export const useAppFoodsBaseFoodsSearchCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appFoodsBaseFoodsSearchCreate>>, TError,void, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof appFoodsBaseFoodsSearchCreate>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getAppFoodsBaseFoodsSearchCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const appFoodsInsightsList = (
    
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<IngredientInsightsList[]>(
      {url: `/app/foods/insights/`, method: 'GET', signal
    },
      options);
    }
  

export const getAppFoodsInsightsListQueryKey = () => {
    return [`/app/foods/insights/`] as const;
    }

    
export const getAppFoodsInsightsListInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof appFoodsInsightsList>>, TError = unknown>( options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appFoodsInsightsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppFoodsInsightsListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appFoodsInsightsList>>> = ({ signal }) => appFoodsInsightsList(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof appFoodsInsightsList>>, TError, TData> & { queryKey: QueryKey }
}

export type AppFoodsInsightsListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof appFoodsInsightsList>>>
export type AppFoodsInsightsListInfiniteQueryError = unknown

export const useAppFoodsInsightsListInfinite = <TData = Awaited<ReturnType<typeof appFoodsInsightsList>>, TError = unknown>(
  options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appFoodsInsightsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppFoodsInsightsListInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAppFoodsInsightsListQueryOptions = <TData = Awaited<ReturnType<typeof appFoodsInsightsList>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appFoodsInsightsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppFoodsInsightsListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appFoodsInsightsList>>> = ({ signal }) => appFoodsInsightsList(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appFoodsInsightsList>>, TError, TData> & { queryKey: QueryKey }
}

export type AppFoodsInsightsListQueryResult = NonNullable<Awaited<ReturnType<typeof appFoodsInsightsList>>>
export type AppFoodsInsightsListQueryError = unknown

export const useAppFoodsInsightsList = <TData = Awaited<ReturnType<typeof appFoodsInsightsList>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appFoodsInsightsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppFoodsInsightsListQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const appHomeRetrieve = (
    
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<Home>(
      {url: `/app/home/`, method: 'GET', signal
    },
      options);
    }
  

export const getAppHomeRetrieveQueryKey = () => {
    return [`/app/home/`] as const;
    }

    
export const getAppHomeRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof appHomeRetrieve>>, TError = unknown>( options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appHomeRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppHomeRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appHomeRetrieve>>> = ({ signal }) => appHomeRetrieve(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof appHomeRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AppHomeRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof appHomeRetrieve>>>
export type AppHomeRetrieveInfiniteQueryError = unknown

export const useAppHomeRetrieveInfinite = <TData = Awaited<ReturnType<typeof appHomeRetrieve>>, TError = unknown>(
  options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appHomeRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppHomeRetrieveInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAppHomeRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof appHomeRetrieve>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appHomeRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppHomeRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appHomeRetrieve>>> = ({ signal }) => appHomeRetrieve(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appHomeRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AppHomeRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof appHomeRetrieve>>>
export type AppHomeRetrieveQueryError = unknown

export const useAppHomeRetrieve = <TData = Awaited<ReturnType<typeof appHomeRetrieve>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appHomeRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppHomeRetrieveQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Unified search endpoint returning a flat list of items that can be added as a ProductIngredient.

Covers 4 types: ingredient, purchased_good, product, base_food.
Deduplication: if a BaseFood or PurchasedGood already has an Ingredient in this org,
only the Ingredient is returned.

Pass ?include=ingredient&include=purchased_good to restrict which types are returned.
 */
export const appIngredientPickerList = (
    params?: AppIngredientPickerListParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<IngredientPickerItem[]>(
      {url: `/app/ingredient-picker/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getAppIngredientPickerListQueryKey = (params?: AppIngredientPickerListParams,) => {
    return [`/app/ingredient-picker/`, ...(params ? [params]: [])] as const;
    }

    
export const getAppIngredientPickerListInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof appIngredientPickerList>>, TError = unknown>(params?: AppIngredientPickerListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appIngredientPickerList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppIngredientPickerListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appIngredientPickerList>>> = ({ signal, pageParam }) => appIngredientPickerList({...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof appIngredientPickerList>>, TError, TData> & { queryKey: QueryKey }
}

export type AppIngredientPickerListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof appIngredientPickerList>>>
export type AppIngredientPickerListInfiniteQueryError = unknown

export const useAppIngredientPickerListInfinite = <TData = Awaited<ReturnType<typeof appIngredientPickerList>>, TError = unknown>(
 params?: AppIngredientPickerListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appIngredientPickerList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppIngredientPickerListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAppIngredientPickerListQueryOptions = <TData = Awaited<ReturnType<typeof appIngredientPickerList>>, TError = unknown>(params?: AppIngredientPickerListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appIngredientPickerList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppIngredientPickerListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appIngredientPickerList>>> = ({ signal }) => appIngredientPickerList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appIngredientPickerList>>, TError, TData> & { queryKey: QueryKey }
}

export type AppIngredientPickerListQueryResult = NonNullable<Awaited<ReturnType<typeof appIngredientPickerList>>>
export type AppIngredientPickerListQueryError = unknown

export const useAppIngredientPickerList = <TData = Awaited<ReturnType<typeof appIngredientPickerList>>, TError = unknown>(
 params?: AppIngredientPickerListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appIngredientPickerList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppIngredientPickerListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Puts a view on the tighter `auth` scope, replacing the default throttles.
 */
export const appLoginCreate = (
    login: Login,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<unknown>(
      {url: `/app/login/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: login
    },
      options);
    }
  


export const getAppLoginCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appLoginCreate>>, TError,{data: Login}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof appLoginCreate>>, TError,{data: Login}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appLoginCreate>>, {data: Login}> = (props) => {
          const {data} = props ?? {};

          return  appLoginCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AppLoginCreateMutationResult = NonNullable<Awaited<ReturnType<typeof appLoginCreate>>>
    export type AppLoginCreateMutationBody = Login
    export type AppLoginCreateMutationError = unknown

    export const useAppLoginCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appLoginCreate>>, TError,{data: Login}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof appLoginCreate>>,
        TError,
        {data: Login},
        TContext
      > => {

      const mutationOptions = getAppLoginCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Calls Django logout method and delete the Token object
assigned to the current User object.

Accepts/Returns nothing.
 */
export const appLogoutCreate = (
    
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<unknown>(
      {url: `/app/logout/`, method: 'POST'
    },
      options);
    }
  


export const getAppLogoutCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appLogoutCreate>>, TError,void, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof appLogoutCreate>>, TError,void, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appLogoutCreate>>, void> = () => {
          

          return  appLogoutCreate(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AppLogoutCreateMutationResult = NonNullable<Awaited<ReturnType<typeof appLogoutCreate>>>
    
    export type AppLogoutCreateMutationError = unknown

    export const useAppLogoutCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appLogoutCreate>>, TError,void, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof appLogoutCreate>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getAppLogoutCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const appPackagingList = (
    
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<PackagingType[]>(
      {url: `/app/packaging/`, method: 'GET', signal
    },
      options);
    }
  

export const getAppPackagingListQueryKey = () => {
    return [`/app/packaging/`] as const;
    }

    
export const getAppPackagingListInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof appPackagingList>>, TError = unknown>( options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appPackagingList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppPackagingListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appPackagingList>>> = ({ signal }) => appPackagingList(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof appPackagingList>>, TError, TData> & { queryKey: QueryKey }
}

export type AppPackagingListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof appPackagingList>>>
export type AppPackagingListInfiniteQueryError = unknown

export const useAppPackagingListInfinite = <TData = Awaited<ReturnType<typeof appPackagingList>>, TError = unknown>(
  options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appPackagingList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppPackagingListInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAppPackagingListQueryOptions = <TData = Awaited<ReturnType<typeof appPackagingList>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appPackagingList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppPackagingListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appPackagingList>>> = ({ signal }) => appPackagingList(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appPackagingList>>, TError, TData> & { queryKey: QueryKey }
}

export type AppPackagingListQueryResult = NonNullable<Awaited<ReturnType<typeof appPackagingList>>>
export type AppPackagingListQueryError = unknown

export const useAppPackagingList = <TData = Awaited<ReturnType<typeof appPackagingList>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appPackagingList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppPackagingListQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const appPackagingCreate = (
    packagingTypeCreate: NonReadonly<PackagingTypeCreate>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<PackagingTypeCreate>(
      {url: `/app/packaging/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: packagingTypeCreate
    },
      options);
    }
  


export const getAppPackagingCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appPackagingCreate>>, TError,{data: NonReadonly<PackagingTypeCreate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof appPackagingCreate>>, TError,{data: NonReadonly<PackagingTypeCreate>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appPackagingCreate>>, {data: NonReadonly<PackagingTypeCreate>}> = (props) => {
          const {data} = props ?? {};

          return  appPackagingCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AppPackagingCreateMutationResult = NonNullable<Awaited<ReturnType<typeof appPackagingCreate>>>
    export type AppPackagingCreateMutationBody = NonReadonly<PackagingTypeCreate>
    export type AppPackagingCreateMutationError = unknown

    export const useAppPackagingCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appPackagingCreate>>, TError,{data: NonReadonly<PackagingTypeCreate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof appPackagingCreate>>,
        TError,
        {data: NonReadonly<PackagingTypeCreate>},
        TContext
      > => {

      const mutationOptions = getAppPackagingCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const appPackagingRetrieve = (
    packagingTypeUuid: string,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<void>(
      {url: `/app/packaging/${packagingTypeUuid}/`, method: 'GET', signal
    },
      options);
    }
  

export const getAppPackagingRetrieveQueryKey = (packagingTypeUuid: string,) => {
    return [`/app/packaging/${packagingTypeUuid}/`] as const;
    }

    
export const getAppPackagingRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof appPackagingRetrieve>>, TError = unknown>(packagingTypeUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appPackagingRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppPackagingRetrieveQueryKey(packagingTypeUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appPackagingRetrieve>>> = ({ signal }) => appPackagingRetrieve(packagingTypeUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(packagingTypeUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof appPackagingRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AppPackagingRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof appPackagingRetrieve>>>
export type AppPackagingRetrieveInfiniteQueryError = unknown

export const useAppPackagingRetrieveInfinite = <TData = Awaited<ReturnType<typeof appPackagingRetrieve>>, TError = unknown>(
 packagingTypeUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appPackagingRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppPackagingRetrieveInfiniteQueryOptions(packagingTypeUuid,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAppPackagingRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof appPackagingRetrieve>>, TError = unknown>(packagingTypeUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appPackagingRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppPackagingRetrieveQueryKey(packagingTypeUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appPackagingRetrieve>>> = ({ signal }) => appPackagingRetrieve(packagingTypeUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(packagingTypeUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appPackagingRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AppPackagingRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof appPackagingRetrieve>>>
export type AppPackagingRetrieveQueryError = unknown

export const useAppPackagingRetrieve = <TData = Awaited<ReturnType<typeof appPackagingRetrieve>>, TError = unknown>(
 packagingTypeUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appPackagingRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppPackagingRetrieveQueryOptions(packagingTypeUuid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Should handle the update of the packaging type description
 */
export const appPackagingUpdate = (
    packagingTypeUuid: string,
    packagingTypeUpdate: NonReadonly<PackagingTypeUpdate>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<PackagingTypeUpdate>(
      {url: `/app/packaging/${packagingTypeUuid}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: packagingTypeUpdate
    },
      options);
    }
  


export const getAppPackagingUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appPackagingUpdate>>, TError,{packagingTypeUuid: string;data: NonReadonly<PackagingTypeUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof appPackagingUpdate>>, TError,{packagingTypeUuid: string;data: NonReadonly<PackagingTypeUpdate>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appPackagingUpdate>>, {packagingTypeUuid: string;data: NonReadonly<PackagingTypeUpdate>}> = (props) => {
          const {packagingTypeUuid,data} = props ?? {};

          return  appPackagingUpdate(packagingTypeUuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AppPackagingUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof appPackagingUpdate>>>
    export type AppPackagingUpdateMutationBody = NonReadonly<PackagingTypeUpdate>
    export type AppPackagingUpdateMutationError = unknown

    export const useAppPackagingUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appPackagingUpdate>>, TError,{packagingTypeUuid: string;data: NonReadonly<PackagingTypeUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof appPackagingUpdate>>,
        TError,
        {packagingTypeUuid: string;data: NonReadonly<PackagingTypeUpdate>},
        TContext
      > => {

      const mutationOptions = getAppPackagingUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const appPackagingFileRetrieve = (
    packagingTypeUuid: string,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<PackagingTypeFileRetrieve>(
      {url: `/app/packaging/${packagingTypeUuid}/file/`, method: 'GET', signal
    },
      options);
    }
  

export const getAppPackagingFileRetrieveQueryKey = (packagingTypeUuid: string,) => {
    return [`/app/packaging/${packagingTypeUuid}/file/`] as const;
    }

    
export const getAppPackagingFileRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof appPackagingFileRetrieve>>, TError = unknown>(packagingTypeUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appPackagingFileRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppPackagingFileRetrieveQueryKey(packagingTypeUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appPackagingFileRetrieve>>> = ({ signal }) => appPackagingFileRetrieve(packagingTypeUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(packagingTypeUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof appPackagingFileRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AppPackagingFileRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof appPackagingFileRetrieve>>>
export type AppPackagingFileRetrieveInfiniteQueryError = unknown

export const useAppPackagingFileRetrieveInfinite = <TData = Awaited<ReturnType<typeof appPackagingFileRetrieve>>, TError = unknown>(
 packagingTypeUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appPackagingFileRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppPackagingFileRetrieveInfiniteQueryOptions(packagingTypeUuid,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAppPackagingFileRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof appPackagingFileRetrieve>>, TError = unknown>(packagingTypeUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appPackagingFileRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppPackagingFileRetrieveQueryKey(packagingTypeUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appPackagingFileRetrieve>>> = ({ signal }) => appPackagingFileRetrieve(packagingTypeUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(packagingTypeUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appPackagingFileRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AppPackagingFileRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof appPackagingFileRetrieve>>>
export type AppPackagingFileRetrieveQueryError = unknown

export const useAppPackagingFileRetrieve = <TData = Awaited<ReturnType<typeof appPackagingFileRetrieve>>, TError = unknown>(
 packagingTypeUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appPackagingFileRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppPackagingFileRetrieveQueryOptions(packagingTypeUuid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const appPackagingFileCreate = (
    packagingTypeUuid: string,
    packagingTypeFileUuid: string,
    packagingTypeFileFinish: PackagingTypeFileFinish,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<PackagingTypeFileFinish>(
      {url: `/app/packaging/${packagingTypeUuid}/file/${packagingTypeFileUuid}/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: packagingTypeFileFinish
    },
      options);
    }
  


export const getAppPackagingFileCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appPackagingFileCreate>>, TError,{packagingTypeUuid: string;packagingTypeFileUuid: string;data: PackagingTypeFileFinish}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof appPackagingFileCreate>>, TError,{packagingTypeUuid: string;packagingTypeFileUuid: string;data: PackagingTypeFileFinish}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appPackagingFileCreate>>, {packagingTypeUuid: string;packagingTypeFileUuid: string;data: PackagingTypeFileFinish}> = (props) => {
          const {packagingTypeUuid,packagingTypeFileUuid,data} = props ?? {};

          return  appPackagingFileCreate(packagingTypeUuid,packagingTypeFileUuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AppPackagingFileCreateMutationResult = NonNullable<Awaited<ReturnType<typeof appPackagingFileCreate>>>
    export type AppPackagingFileCreateMutationBody = PackagingTypeFileFinish
    export type AppPackagingFileCreateMutationError = unknown

    export const useAppPackagingFileCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appPackagingFileCreate>>, TError,{packagingTypeUuid: string;packagingTypeFileUuid: string;data: PackagingTypeFileFinish}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof appPackagingFileCreate>>,
        TError,
        {packagingTypeUuid: string;packagingTypeFileUuid: string;data: PackagingTypeFileFinish},
        TContext
      > => {

      const mutationOptions = getAppPackagingFileCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Read-only packaging types consumed by Reggie's item cleanup pipeline.
 */
export const appPackagingTypesRetrieve = (
    
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<void>(
      {url: `/app/packaging/types/`, method: 'GET', signal
    },
      options);
    }
  

export const getAppPackagingTypesRetrieveQueryKey = () => {
    return [`/app/packaging/types/`] as const;
    }

    
export const getAppPackagingTypesRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof appPackagingTypesRetrieve>>, TError = unknown>( options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appPackagingTypesRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppPackagingTypesRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appPackagingTypesRetrieve>>> = ({ signal }) => appPackagingTypesRetrieve(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof appPackagingTypesRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AppPackagingTypesRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof appPackagingTypesRetrieve>>>
export type AppPackagingTypesRetrieveInfiniteQueryError = unknown

export const useAppPackagingTypesRetrieveInfinite = <TData = Awaited<ReturnType<typeof appPackagingTypesRetrieve>>, TError = unknown>(
  options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appPackagingTypesRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppPackagingTypesRetrieveInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAppPackagingTypesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof appPackagingTypesRetrieve>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appPackagingTypesRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppPackagingTypesRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appPackagingTypesRetrieve>>> = ({ signal }) => appPackagingTypesRetrieve(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appPackagingTypesRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AppPackagingTypesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof appPackagingTypesRetrieve>>>
export type AppPackagingTypesRetrieveQueryError = unknown

export const useAppPackagingTypesRetrieve = <TData = Awaited<ReturnType<typeof appPackagingTypesRetrieve>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appPackagingTypesRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppPackagingTypesRetrieveQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Calls Django Auth SetPasswordForm save method.

Accepts the following POST parameters: new_password1, new_password2
Returns the success/fail message.
 */
export const appPasswordChangeCreate = (
    passwordChange: PasswordChange,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<unknown>(
      {url: `/app/password/change/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: passwordChange
    },
      options);
    }
  


export const getAppPasswordChangeCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appPasswordChangeCreate>>, TError,{data: PasswordChange}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof appPasswordChangeCreate>>, TError,{data: PasswordChange}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appPasswordChangeCreate>>, {data: PasswordChange}> = (props) => {
          const {data} = props ?? {};

          return  appPasswordChangeCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AppPasswordChangeCreateMutationResult = NonNullable<Awaited<ReturnType<typeof appPasswordChangeCreate>>>
    export type AppPasswordChangeCreateMutationBody = PasswordChange
    export type AppPasswordChangeCreateMutationError = unknown

    export const useAppPasswordChangeCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appPasswordChangeCreate>>, TError,{data: PasswordChange}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof appPasswordChangeCreate>>,
        TError,
        {data: PasswordChange},
        TContext
      > => {

      const mutationOptions = getAppPasswordChangeCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Password reset request, rate limited per client IP.
 */
export const appPasswordResetCreate = (
    myPasswordReset: MyPasswordReset,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<unknown>(
      {url: `/app/password/reset/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: myPasswordReset
    },
      options);
    }
  


export const getAppPasswordResetCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appPasswordResetCreate>>, TError,{data: MyPasswordReset}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof appPasswordResetCreate>>, TError,{data: MyPasswordReset}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appPasswordResetCreate>>, {data: MyPasswordReset}> = (props) => {
          const {data} = props ?? {};

          return  appPasswordResetCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AppPasswordResetCreateMutationResult = NonNullable<Awaited<ReturnType<typeof appPasswordResetCreate>>>
    export type AppPasswordResetCreateMutationBody = MyPasswordReset
    export type AppPasswordResetCreateMutationError = unknown

    export const useAppPasswordResetCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appPasswordResetCreate>>, TError,{data: MyPasswordReset}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof appPasswordResetCreate>>,
        TError,
        {data: MyPasswordReset},
        TContext
      > => {

      const mutationOptions = getAppPasswordResetCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Password reset confirmation, rate limited per client IP.
 */
export const appPasswordResetConfirmCreate = (
    uidb64: string,
    token: string,
    passwordResetConfirm: PasswordResetConfirm,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<unknown>(
      {url: `/app/password/reset/confirm/${uidb64}/${token}/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: passwordResetConfirm
    },
      options);
    }
  


export const getAppPasswordResetConfirmCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appPasswordResetConfirmCreate>>, TError,{uidb64: string;token: string;data: PasswordResetConfirm}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof appPasswordResetConfirmCreate>>, TError,{uidb64: string;token: string;data: PasswordResetConfirm}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appPasswordResetConfirmCreate>>, {uidb64: string;token: string;data: PasswordResetConfirm}> = (props) => {
          const {uidb64,token,data} = props ?? {};

          return  appPasswordResetConfirmCreate(uidb64,token,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AppPasswordResetConfirmCreateMutationResult = NonNullable<Awaited<ReturnType<typeof appPasswordResetConfirmCreate>>>
    export type AppPasswordResetConfirmCreateMutationBody = PasswordResetConfirm
    export type AppPasswordResetConfirmCreateMutationError = unknown

    export const useAppPasswordResetConfirmCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appPasswordResetConfirmCreate>>, TError,{uidb64: string;token: string;data: PasswordResetConfirm}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof appPasswordResetConfirmCreate>>,
        TError,
        {uidb64: string;token: string;data: PasswordResetConfirm},
        TContext
      > => {

      const mutationOptions = getAppPasswordResetConfirmCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const appProcessingList = (
    
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<ProcessingTypeList[]>(
      {url: `/app/processing/`, method: 'GET', signal
    },
      options);
    }
  

export const getAppProcessingListQueryKey = () => {
    return [`/app/processing/`] as const;
    }

    
export const getAppProcessingListInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof appProcessingList>>, TError = unknown>( options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appProcessingList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppProcessingListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appProcessingList>>> = ({ signal }) => appProcessingList(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof appProcessingList>>, TError, TData> & { queryKey: QueryKey }
}

export type AppProcessingListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof appProcessingList>>>
export type AppProcessingListInfiniteQueryError = unknown

export const useAppProcessingListInfinite = <TData = Awaited<ReturnType<typeof appProcessingList>>, TError = unknown>(
  options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appProcessingList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppProcessingListInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAppProcessingListQueryOptions = <TData = Awaited<ReturnType<typeof appProcessingList>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appProcessingList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppProcessingListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appProcessingList>>> = ({ signal }) => appProcessingList(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appProcessingList>>, TError, TData> & { queryKey: QueryKey }
}

export type AppProcessingListQueryResult = NonNullable<Awaited<ReturnType<typeof appProcessingList>>>
export type AppProcessingListQueryError = unknown

export const useAppProcessingList = <TData = Awaited<ReturnType<typeof appProcessingList>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appProcessingList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppProcessingListQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const appProcessingCreate = (
    processingTypeCreate: NonReadonly<ProcessingTypeCreate>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<ProcessingTypeCreate>(
      {url: `/app/processing/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: processingTypeCreate
    },
      options);
    }
  


export const getAppProcessingCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appProcessingCreate>>, TError,{data: NonReadonly<ProcessingTypeCreate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof appProcessingCreate>>, TError,{data: NonReadonly<ProcessingTypeCreate>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appProcessingCreate>>, {data: NonReadonly<ProcessingTypeCreate>}> = (props) => {
          const {data} = props ?? {};

          return  appProcessingCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AppProcessingCreateMutationResult = NonNullable<Awaited<ReturnType<typeof appProcessingCreate>>>
    export type AppProcessingCreateMutationBody = NonReadonly<ProcessingTypeCreate>
    export type AppProcessingCreateMutationError = unknown

    export const useAppProcessingCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appProcessingCreate>>, TError,{data: NonReadonly<ProcessingTypeCreate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof appProcessingCreate>>,
        TError,
        {data: NonReadonly<ProcessingTypeCreate>},
        TContext
      > => {

      const mutationOptions = getAppProcessingCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const appProcessingRetrieve = (
    processingTypeUuid: string,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<ProcessingTypeList>(
      {url: `/app/processing/${processingTypeUuid}/`, method: 'GET', signal
    },
      options);
    }
  

export const getAppProcessingRetrieveQueryKey = (processingTypeUuid: string,) => {
    return [`/app/processing/${processingTypeUuid}/`] as const;
    }

    
export const getAppProcessingRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof appProcessingRetrieve>>, TError = unknown>(processingTypeUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appProcessingRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppProcessingRetrieveQueryKey(processingTypeUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appProcessingRetrieve>>> = ({ signal }) => appProcessingRetrieve(processingTypeUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(processingTypeUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof appProcessingRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AppProcessingRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof appProcessingRetrieve>>>
export type AppProcessingRetrieveInfiniteQueryError = unknown

export const useAppProcessingRetrieveInfinite = <TData = Awaited<ReturnType<typeof appProcessingRetrieve>>, TError = unknown>(
 processingTypeUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appProcessingRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppProcessingRetrieveInfiniteQueryOptions(processingTypeUuid,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAppProcessingRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof appProcessingRetrieve>>, TError = unknown>(processingTypeUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appProcessingRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppProcessingRetrieveQueryKey(processingTypeUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appProcessingRetrieve>>> = ({ signal }) => appProcessingRetrieve(processingTypeUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(processingTypeUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appProcessingRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AppProcessingRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof appProcessingRetrieve>>>
export type AppProcessingRetrieveQueryError = unknown

export const useAppProcessingRetrieve = <TData = Awaited<ReturnType<typeof appProcessingRetrieve>>, TError = unknown>(
 processingTypeUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appProcessingRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppProcessingRetrieveQueryOptions(processingTypeUuid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const appProcessingUpdate = (
    processingTypeUuid: string,
    processingTypeUpdate: NonReadonly<ProcessingTypeUpdate>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<ProcessingTypeUpdate>(
      {url: `/app/processing/${processingTypeUuid}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: processingTypeUpdate
    },
      options);
    }
  


export const getAppProcessingUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appProcessingUpdate>>, TError,{processingTypeUuid: string;data: NonReadonly<ProcessingTypeUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof appProcessingUpdate>>, TError,{processingTypeUuid: string;data: NonReadonly<ProcessingTypeUpdate>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appProcessingUpdate>>, {processingTypeUuid: string;data: NonReadonly<ProcessingTypeUpdate>}> = (props) => {
          const {processingTypeUuid,data} = props ?? {};

          return  appProcessingUpdate(processingTypeUuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AppProcessingUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof appProcessingUpdate>>>
    export type AppProcessingUpdateMutationBody = NonReadonly<ProcessingTypeUpdate>
    export type AppProcessingUpdateMutationError = unknown

    export const useAppProcessingUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appProcessingUpdate>>, TError,{processingTypeUuid: string;data: NonReadonly<ProcessingTypeUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof appProcessingUpdate>>,
        TError,
        {processingTypeUuid: string;data: NonReadonly<ProcessingTypeUpdate>},
        TContext
      > => {

      const mutationOptions = getAppProcessingUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const appProcessingPartialUpdate = (
    processingTypeUuid: string,
    patchedProcessingTypeUpdate: NonReadonly<PatchedProcessingTypeUpdate>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<ProcessingTypeUpdate>(
      {url: `/app/processing/${processingTypeUuid}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedProcessingTypeUpdate
    },
      options);
    }
  


export const getAppProcessingPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appProcessingPartialUpdate>>, TError,{processingTypeUuid: string;data: NonReadonly<PatchedProcessingTypeUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof appProcessingPartialUpdate>>, TError,{processingTypeUuid: string;data: NonReadonly<PatchedProcessingTypeUpdate>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appProcessingPartialUpdate>>, {processingTypeUuid: string;data: NonReadonly<PatchedProcessingTypeUpdate>}> = (props) => {
          const {processingTypeUuid,data} = props ?? {};

          return  appProcessingPartialUpdate(processingTypeUuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AppProcessingPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof appProcessingPartialUpdate>>>
    export type AppProcessingPartialUpdateMutationBody = NonReadonly<PatchedProcessingTypeUpdate>
    export type AppProcessingPartialUpdateMutationError = unknown

    export const useAppProcessingPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appProcessingPartialUpdate>>, TError,{processingTypeUuid: string;data: NonReadonly<PatchedProcessingTypeUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof appProcessingPartialUpdate>>,
        TError,
        {processingTypeUuid: string;data: NonReadonly<PatchedProcessingTypeUpdate>},
        TContext
      > => {

      const mutationOptions = getAppProcessingPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const appProcessingDestroy = (
    processingTypeUuid: string,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<void>(
      {url: `/app/processing/${processingTypeUuid}/`, method: 'DELETE'
    },
      options);
    }
  


export const getAppProcessingDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appProcessingDestroy>>, TError,{processingTypeUuid: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof appProcessingDestroy>>, TError,{processingTypeUuid: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appProcessingDestroy>>, {processingTypeUuid: string}> = (props) => {
          const {processingTypeUuid} = props ?? {};

          return  appProcessingDestroy(processingTypeUuid,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AppProcessingDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof appProcessingDestroy>>>
    
    export type AppProcessingDestroyMutationError = unknown

    export const useAppProcessingDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appProcessingDestroy>>, TError,{processingTypeUuid: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof appProcessingDestroy>>,
        TError,
        {processingTypeUuid: string},
        TContext
      > => {

      const mutationOptions = getAppProcessingDestroyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const appProcessingFileRetrieve = (
    processingTypeUuid: string,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<ProcessingTypeFileRetrieve>(
      {url: `/app/processing/${processingTypeUuid}/file/`, method: 'GET', signal
    },
      options);
    }
  

export const getAppProcessingFileRetrieveQueryKey = (processingTypeUuid: string,) => {
    return [`/app/processing/${processingTypeUuid}/file/`] as const;
    }

    
export const getAppProcessingFileRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof appProcessingFileRetrieve>>, TError = unknown>(processingTypeUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appProcessingFileRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppProcessingFileRetrieveQueryKey(processingTypeUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appProcessingFileRetrieve>>> = ({ signal }) => appProcessingFileRetrieve(processingTypeUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(processingTypeUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof appProcessingFileRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AppProcessingFileRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof appProcessingFileRetrieve>>>
export type AppProcessingFileRetrieveInfiniteQueryError = unknown

export const useAppProcessingFileRetrieveInfinite = <TData = Awaited<ReturnType<typeof appProcessingFileRetrieve>>, TError = unknown>(
 processingTypeUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appProcessingFileRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppProcessingFileRetrieveInfiniteQueryOptions(processingTypeUuid,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAppProcessingFileRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof appProcessingFileRetrieve>>, TError = unknown>(processingTypeUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appProcessingFileRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppProcessingFileRetrieveQueryKey(processingTypeUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appProcessingFileRetrieve>>> = ({ signal }) => appProcessingFileRetrieve(processingTypeUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(processingTypeUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appProcessingFileRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AppProcessingFileRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof appProcessingFileRetrieve>>>
export type AppProcessingFileRetrieveQueryError = unknown

export const useAppProcessingFileRetrieve = <TData = Awaited<ReturnType<typeof appProcessingFileRetrieve>>, TError = unknown>(
 processingTypeUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appProcessingFileRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppProcessingFileRetrieveQueryOptions(processingTypeUuid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const appProcessingFileCreate = (
    processingTypeUuid: string,
    processingTypeFileUuid: string,
    processingTypeFileFinish: ProcessingTypeFileFinish,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<ProcessingTypeFileFinish>(
      {url: `/app/processing/${processingTypeUuid}/file/${processingTypeFileUuid}/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: processingTypeFileFinish
    },
      options);
    }
  


export const getAppProcessingFileCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appProcessingFileCreate>>, TError,{processingTypeUuid: string;processingTypeFileUuid: string;data: ProcessingTypeFileFinish}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof appProcessingFileCreate>>, TError,{processingTypeUuid: string;processingTypeFileUuid: string;data: ProcessingTypeFileFinish}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appProcessingFileCreate>>, {processingTypeUuid: string;processingTypeFileUuid: string;data: ProcessingTypeFileFinish}> = (props) => {
          const {processingTypeUuid,processingTypeFileUuid,data} = props ?? {};

          return  appProcessingFileCreate(processingTypeUuid,processingTypeFileUuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AppProcessingFileCreateMutationResult = NonNullable<Awaited<ReturnType<typeof appProcessingFileCreate>>>
    export type AppProcessingFileCreateMutationBody = ProcessingTypeFileFinish
    export type AppProcessingFileCreateMutationError = unknown

    export const useAppProcessingFileCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appProcessingFileCreate>>, TError,{processingTypeUuid: string;processingTypeFileUuid: string;data: ProcessingTypeFileFinish}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof appProcessingFileCreate>>,
        TError,
        {processingTypeUuid: string;processingTypeFileUuid: string;data: ProcessingTypeFileFinish},
        TContext
      > => {

      const mutationOptions = getAppProcessingFileCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const appProductsList = (
    params?: AppProductsListParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<PaginatedProductListList>(
      {url: `/app/products/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getAppProductsListQueryKey = (params?: AppProductsListParams,) => {
    return [`/app/products/`, ...(params ? [params]: [])] as const;
    }

    
export const getAppProductsListInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof appProductsList>>, TError = unknown>(params?: AppProductsListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appProductsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppProductsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appProductsList>>> = ({ signal, pageParam }) => appProductsList({...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof appProductsList>>, TError, TData> & { queryKey: QueryKey }
}

export type AppProductsListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof appProductsList>>>
export type AppProductsListInfiniteQueryError = unknown

export const useAppProductsListInfinite = <TData = Awaited<ReturnType<typeof appProductsList>>, TError = unknown>(
 params?: AppProductsListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appProductsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppProductsListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAppProductsListQueryOptions = <TData = Awaited<ReturnType<typeof appProductsList>>, TError = unknown>(params?: AppProductsListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appProductsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppProductsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appProductsList>>> = ({ signal }) => appProductsList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appProductsList>>, TError, TData> & { queryKey: QueryKey }
}

export type AppProductsListQueryResult = NonNullable<Awaited<ReturnType<typeof appProductsList>>>
export type AppProductsListQueryError = unknown

export const useAppProductsList = <TData = Awaited<ReturnType<typeof appProductsList>>, TError = unknown>(
 params?: AppProductsListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appProductsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppProductsListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const appProductsCreate = (
    productCreateUpdate: NonReadonly<ProductCreateUpdate>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<ProductCreateUpdate>(
      {url: `/app/products/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: productCreateUpdate
    },
      options);
    }
  


export const getAppProductsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appProductsCreate>>, TError,{data: NonReadonly<ProductCreateUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof appProductsCreate>>, TError,{data: NonReadonly<ProductCreateUpdate>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appProductsCreate>>, {data: NonReadonly<ProductCreateUpdate>}> = (props) => {
          const {data} = props ?? {};

          return  appProductsCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AppProductsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof appProductsCreate>>>
    export type AppProductsCreateMutationBody = NonReadonly<ProductCreateUpdate>
    export type AppProductsCreateMutationError = unknown

    export const useAppProductsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appProductsCreate>>, TError,{data: NonReadonly<ProductCreateUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof appProductsCreate>>,
        TError,
        {data: NonReadonly<ProductCreateUpdate>},
        TContext
      > => {

      const mutationOptions = getAppProductsCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const appProductsRetrieve = (
    productUuid: string,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<ProductDetail>(
      {url: `/app/products/${productUuid}/`, method: 'GET', signal
    },
      options);
    }
  

export const getAppProductsRetrieveQueryKey = (productUuid: string,) => {
    return [`/app/products/${productUuid}/`] as const;
    }

    
export const getAppProductsRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof appProductsRetrieve>>, TError = unknown>(productUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appProductsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppProductsRetrieveQueryKey(productUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appProductsRetrieve>>> = ({ signal }) => appProductsRetrieve(productUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(productUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof appProductsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AppProductsRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof appProductsRetrieve>>>
export type AppProductsRetrieveInfiniteQueryError = unknown

export const useAppProductsRetrieveInfinite = <TData = Awaited<ReturnType<typeof appProductsRetrieve>>, TError = unknown>(
 productUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appProductsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppProductsRetrieveInfiniteQueryOptions(productUuid,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAppProductsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof appProductsRetrieve>>, TError = unknown>(productUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appProductsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppProductsRetrieveQueryKey(productUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appProductsRetrieve>>> = ({ signal }) => appProductsRetrieve(productUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(productUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appProductsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AppProductsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof appProductsRetrieve>>>
export type AppProductsRetrieveQueryError = unknown

export const useAppProductsRetrieve = <TData = Awaited<ReturnType<typeof appProductsRetrieve>>, TError = unknown>(
 productUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appProductsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppProductsRetrieveQueryOptions(productUuid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const appProductsUpdate = (
    productUuid: string,
    productCreateUpdate: NonReadonly<ProductCreateUpdate>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<ProductCreateUpdate>(
      {url: `/app/products/${productUuid}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: productCreateUpdate
    },
      options);
    }
  


export const getAppProductsUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appProductsUpdate>>, TError,{productUuid: string;data: NonReadonly<ProductCreateUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof appProductsUpdate>>, TError,{productUuid: string;data: NonReadonly<ProductCreateUpdate>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appProductsUpdate>>, {productUuid: string;data: NonReadonly<ProductCreateUpdate>}> = (props) => {
          const {productUuid,data} = props ?? {};

          return  appProductsUpdate(productUuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AppProductsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof appProductsUpdate>>>
    export type AppProductsUpdateMutationBody = NonReadonly<ProductCreateUpdate>
    export type AppProductsUpdateMutationError = unknown

    export const useAppProductsUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appProductsUpdate>>, TError,{productUuid: string;data: NonReadonly<ProductCreateUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof appProductsUpdate>>,
        TError,
        {productUuid: string;data: NonReadonly<ProductCreateUpdate>},
        TContext
      > => {

      const mutationOptions = getAppProductsUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const appProductsPartialUpdate = (
    productUuid: string,
    patchedProductCreateUpdate: NonReadonly<PatchedProductCreateUpdate>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<ProductCreateUpdate>(
      {url: `/app/products/${productUuid}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedProductCreateUpdate
    },
      options);
    }
  


export const getAppProductsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appProductsPartialUpdate>>, TError,{productUuid: string;data: NonReadonly<PatchedProductCreateUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof appProductsPartialUpdate>>, TError,{productUuid: string;data: NonReadonly<PatchedProductCreateUpdate>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appProductsPartialUpdate>>, {productUuid: string;data: NonReadonly<PatchedProductCreateUpdate>}> = (props) => {
          const {productUuid,data} = props ?? {};

          return  appProductsPartialUpdate(productUuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AppProductsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof appProductsPartialUpdate>>>
    export type AppProductsPartialUpdateMutationBody = NonReadonly<PatchedProductCreateUpdate>
    export type AppProductsPartialUpdateMutationError = unknown

    export const useAppProductsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appProductsPartialUpdate>>, TError,{productUuid: string;data: NonReadonly<PatchedProductCreateUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof appProductsPartialUpdate>>,
        TError,
        {productUuid: string;data: NonReadonly<PatchedProductCreateUpdate>},
        TContext
      > => {

      const mutationOptions = getAppProductsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const appProductsDestroy = (
    productUuid: string,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<void>(
      {url: `/app/products/${productUuid}/`, method: 'DELETE'
    },
      options);
    }
  


export const getAppProductsDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appProductsDestroy>>, TError,{productUuid: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof appProductsDestroy>>, TError,{productUuid: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appProductsDestroy>>, {productUuid: string}> = (props) => {
          const {productUuid} = props ?? {};

          return  appProductsDestroy(productUuid,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AppProductsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof appProductsDestroy>>>
    
    export type AppProductsDestroyMutationError = unknown

    export const useAppProductsDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appProductsDestroy>>, TError,{productUuid: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof appProductsDestroy>>,
        TError,
        {productUuid: string},
        TContext
      > => {

      const mutationOptions = getAppProductsDestroyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * View which accepts a post request to duplicate an existing product.
 */
export const appProductsDuplicateCreate = (
    productUuid: string,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<void>(
      {url: `/app/products/${productUuid}/duplicate/`, method: 'POST'
    },
      options);
    }
  


export const getAppProductsDuplicateCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appProductsDuplicateCreate>>, TError,{productUuid: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof appProductsDuplicateCreate>>, TError,{productUuid: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appProductsDuplicateCreate>>, {productUuid: string}> = (props) => {
          const {productUuid} = props ?? {};

          return  appProductsDuplicateCreate(productUuid,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AppProductsDuplicateCreateMutationResult = NonNullable<Awaited<ReturnType<typeof appProductsDuplicateCreate>>>
    
    export type AppProductsDuplicateCreateMutationError = unknown

    export const useAppProductsDuplicateCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appProductsDuplicateCreate>>, TError,{productUuid: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof appProductsDuplicateCreate>>,
        TError,
        {productUuid: string},
        TContext
      > => {

      const mutationOptions = getAppProductsDuplicateCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * View which accepts a post request to move a product back to editable status (Draft)

All that happens at the moment is that the status is moved to Draft
 */
export const appProductsEditCreate = (
    productUuid: string,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<void>(
      {url: `/app/products/${productUuid}/edit/`, method: 'POST'
    },
      options);
    }
  


export const getAppProductsEditCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appProductsEditCreate>>, TError,{productUuid: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof appProductsEditCreate>>, TError,{productUuid: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appProductsEditCreate>>, {productUuid: string}> = (props) => {
          const {productUuid} = props ?? {};

          return  appProductsEditCreate(productUuid,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AppProductsEditCreateMutationResult = NonNullable<Awaited<ReturnType<typeof appProductsEditCreate>>>
    
    export type AppProductsEditCreateMutationError = unknown

    export const useAppProductsEditCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appProductsEditCreate>>, TError,{productUuid: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof appProductsEditCreate>>,
        TError,
        {productUuid: string},
        TContext
      > => {

      const mutationOptions = getAppProductsEditCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const appProductsResultRetrieve = (
    productUuid: string,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<ProductResult>(
      {url: `/app/products/${productUuid}/result/`, method: 'GET', signal
    },
      options);
    }
  

export const getAppProductsResultRetrieveQueryKey = (productUuid: string,) => {
    return [`/app/products/${productUuid}/result/`] as const;
    }

    
export const getAppProductsResultRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof appProductsResultRetrieve>>, TError = unknown>(productUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appProductsResultRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppProductsResultRetrieveQueryKey(productUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appProductsResultRetrieve>>> = ({ signal }) => appProductsResultRetrieve(productUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(productUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof appProductsResultRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AppProductsResultRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof appProductsResultRetrieve>>>
export type AppProductsResultRetrieveInfiniteQueryError = unknown

export const useAppProductsResultRetrieveInfinite = <TData = Awaited<ReturnType<typeof appProductsResultRetrieve>>, TError = unknown>(
 productUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appProductsResultRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppProductsResultRetrieveInfiniteQueryOptions(productUuid,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAppProductsResultRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof appProductsResultRetrieve>>, TError = unknown>(productUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appProductsResultRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppProductsResultRetrieveQueryKey(productUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appProductsResultRetrieve>>> = ({ signal }) => appProductsResultRetrieve(productUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(productUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appProductsResultRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AppProductsResultRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof appProductsResultRetrieve>>>
export type AppProductsResultRetrieveQueryError = unknown

export const useAppProductsResultRetrieve = <TData = Awaited<ReturnType<typeof appProductsResultRetrieve>>, TError = unknown>(
 productUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appProductsResultRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppProductsResultRetrieveQueryOptions(productUuid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * View which accepts a post request to submit a product for assessment

All that happens at the moment is that the status is moved to In Progress
 */
export const appProductsSubmitCreate = (
    productUuid: string,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<void>(
      {url: `/app/products/${productUuid}/submit/`, method: 'POST'
    },
      options);
    }
  


export const getAppProductsSubmitCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appProductsSubmitCreate>>, TError,{productUuid: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof appProductsSubmitCreate>>, TError,{productUuid: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appProductsSubmitCreate>>, {productUuid: string}> = (props) => {
          const {productUuid} = props ?? {};

          return  appProductsSubmitCreate(productUuid,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AppProductsSubmitCreateMutationResult = NonNullable<Awaited<ReturnType<typeof appProductsSubmitCreate>>>
    
    export type AppProductsSubmitCreateMutationError = unknown

    export const useAppProductsSubmitCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appProductsSubmitCreate>>, TError,{productUuid: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof appProductsSubmitCreate>>,
        TError,
        {productUuid: string},
        TContext
      > => {

      const mutationOptions = getAppProductsSubmitCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const appProductsAssessCreate = (
    assessRequest: AssessRequest,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<AssessResponse>(
      {url: `/app/products/assess`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: assessRequest
    },
      options);
    }
  


export const getAppProductsAssessCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appProductsAssessCreate>>, TError,{data: AssessRequest}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof appProductsAssessCreate>>, TError,{data: AssessRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appProductsAssessCreate>>, {data: AssessRequest}> = (props) => {
          const {data} = props ?? {};

          return  appProductsAssessCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AppProductsAssessCreateMutationResult = NonNullable<Awaited<ReturnType<typeof appProductsAssessCreate>>>
    export type AppProductsAssessCreateMutationBody = AssessRequest
    export type AppProductsAssessCreateMutationError = void

    export const useAppProductsAssessCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appProductsAssessCreate>>, TError,{data: AssessRequest}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof appProductsAssessCreate>>,
        TError,
        {data: AssessRequest},
        TContext
      > => {

      const mutationOptions = getAppProductsAssessCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const appProductsCsvRetrieve = (
    
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<void>(
      {url: `/app/products/csv/`, method: 'GET', signal
    },
      options);
    }
  

export const getAppProductsCsvRetrieveQueryKey = () => {
    return [`/app/products/csv/`] as const;
    }

    
export const getAppProductsCsvRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof appProductsCsvRetrieve>>, TError = unknown>( options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appProductsCsvRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppProductsCsvRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appProductsCsvRetrieve>>> = ({ signal }) => appProductsCsvRetrieve(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof appProductsCsvRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AppProductsCsvRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof appProductsCsvRetrieve>>>
export type AppProductsCsvRetrieveInfiniteQueryError = unknown

export const useAppProductsCsvRetrieveInfinite = <TData = Awaited<ReturnType<typeof appProductsCsvRetrieve>>, TError = unknown>(
  options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appProductsCsvRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppProductsCsvRetrieveInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAppProductsCsvRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof appProductsCsvRetrieve>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appProductsCsvRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppProductsCsvRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appProductsCsvRetrieve>>> = ({ signal }) => appProductsCsvRetrieve(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appProductsCsvRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AppProductsCsvRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof appProductsCsvRetrieve>>>
export type AppProductsCsvRetrieveQueryError = unknown

export const useAppProductsCsvRetrieve = <TData = Awaited<ReturnType<typeof appProductsCsvRetrieve>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appProductsCsvRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppProductsCsvRetrieveQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const appReportsList = (
    
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<Report[]>(
      {url: `/app/reports/`, method: 'GET', signal
    },
      options);
    }
  

export const getAppReportsListQueryKey = () => {
    return [`/app/reports/`] as const;
    }

    
export const getAppReportsListInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof appReportsList>>, TError = unknown>( options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appReportsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppReportsListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appReportsList>>> = ({ signal }) => appReportsList(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof appReportsList>>, TError, TData> & { queryKey: QueryKey }
}

export type AppReportsListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof appReportsList>>>
export type AppReportsListInfiniteQueryError = unknown

export const useAppReportsListInfinite = <TData = Awaited<ReturnType<typeof appReportsList>>, TError = unknown>(
  options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appReportsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppReportsListInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAppReportsListQueryOptions = <TData = Awaited<ReturnType<typeof appReportsList>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appReportsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppReportsListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appReportsList>>> = ({ signal }) => appReportsList(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appReportsList>>, TError, TData> & { queryKey: QueryKey }
}

export type AppReportsListQueryResult = NonNullable<Awaited<ReturnType<typeof appReportsList>>>
export type AppReportsListQueryError = unknown

export const useAppReportsList = <TData = Awaited<ReturnType<typeof appReportsList>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appReportsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppReportsListQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const appReportsProductionRetrieve = (
    reportUuid: string,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<ReportProductDetail>(
      {url: `/app/reports/production/${reportUuid}/`, method: 'GET', signal
    },
      options);
    }
  

export const getAppReportsProductionRetrieveQueryKey = (reportUuid: string,) => {
    return [`/app/reports/production/${reportUuid}/`] as const;
    }

    
export const getAppReportsProductionRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof appReportsProductionRetrieve>>, TError = unknown>(reportUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appReportsProductionRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppReportsProductionRetrieveQueryKey(reportUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appReportsProductionRetrieve>>> = ({ signal }) => appReportsProductionRetrieve(reportUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(reportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof appReportsProductionRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AppReportsProductionRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof appReportsProductionRetrieve>>>
export type AppReportsProductionRetrieveInfiniteQueryError = unknown

export const useAppReportsProductionRetrieveInfinite = <TData = Awaited<ReturnType<typeof appReportsProductionRetrieve>>, TError = unknown>(
 reportUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appReportsProductionRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppReportsProductionRetrieveInfiniteQueryOptions(reportUuid,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAppReportsProductionRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof appReportsProductionRetrieve>>, TError = unknown>(reportUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appReportsProductionRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppReportsProductionRetrieveQueryKey(reportUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appReportsProductionRetrieve>>> = ({ signal }) => appReportsProductionRetrieve(reportUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(reportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appReportsProductionRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AppReportsProductionRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof appReportsProductionRetrieve>>>
export type AppReportsProductionRetrieveQueryError = unknown

export const useAppReportsProductionRetrieve = <TData = Awaited<ReturnType<typeof appReportsProductionRetrieve>>, TError = unknown>(
 reportUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appReportsProductionRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppReportsProductionRetrieveQueryOptions(reportUuid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const appReportsPurchasingRetrieve = (
    reportUuid: string,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<ReportOrganizationFoodDetail>(
      {url: `/app/reports/purchasing/${reportUuid}/`, method: 'GET', signal
    },
      options);
    }
  

export const getAppReportsPurchasingRetrieveQueryKey = (reportUuid: string,) => {
    return [`/app/reports/purchasing/${reportUuid}/`] as const;
    }

    
export const getAppReportsPurchasingRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof appReportsPurchasingRetrieve>>, TError = unknown>(reportUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appReportsPurchasingRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppReportsPurchasingRetrieveQueryKey(reportUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appReportsPurchasingRetrieve>>> = ({ signal }) => appReportsPurchasingRetrieve(reportUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(reportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof appReportsPurchasingRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AppReportsPurchasingRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof appReportsPurchasingRetrieve>>>
export type AppReportsPurchasingRetrieveInfiniteQueryError = unknown

export const useAppReportsPurchasingRetrieveInfinite = <TData = Awaited<ReturnType<typeof appReportsPurchasingRetrieve>>, TError = unknown>(
 reportUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appReportsPurchasingRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppReportsPurchasingRetrieveInfiniteQueryOptions(reportUuid,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAppReportsPurchasingRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof appReportsPurchasingRetrieve>>, TError = unknown>(reportUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appReportsPurchasingRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppReportsPurchasingRetrieveQueryKey(reportUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appReportsPurchasingRetrieve>>> = ({ signal }) => appReportsPurchasingRetrieve(reportUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(reportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appReportsPurchasingRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AppReportsPurchasingRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof appReportsPurchasingRetrieve>>>
export type AppReportsPurchasingRetrieveQueryError = unknown

export const useAppReportsPurchasingRetrieve = <TData = Awaited<ReturnType<typeof appReportsPurchasingRetrieve>>, TError = unknown>(
 reportUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appReportsPurchasingRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppReportsPurchasingRetrieveQueryOptions(reportUuid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const appReportsSalesRetrieve = (
    reportUuid: string,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<ReportProductDetail>(
      {url: `/app/reports/sales/${reportUuid}/`, method: 'GET', signal
    },
      options);
    }
  

export const getAppReportsSalesRetrieveQueryKey = (reportUuid: string,) => {
    return [`/app/reports/sales/${reportUuid}/`] as const;
    }

    
export const getAppReportsSalesRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof appReportsSalesRetrieve>>, TError = unknown>(reportUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appReportsSalesRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppReportsSalesRetrieveQueryKey(reportUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appReportsSalesRetrieve>>> = ({ signal }) => appReportsSalesRetrieve(reportUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(reportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof appReportsSalesRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AppReportsSalesRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof appReportsSalesRetrieve>>>
export type AppReportsSalesRetrieveInfiniteQueryError = unknown

export const useAppReportsSalesRetrieveInfinite = <TData = Awaited<ReturnType<typeof appReportsSalesRetrieve>>, TError = unknown>(
 reportUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appReportsSalesRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppReportsSalesRetrieveInfiniteQueryOptions(reportUuid,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAppReportsSalesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof appReportsSalesRetrieve>>, TError = unknown>(reportUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appReportsSalesRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppReportsSalesRetrieveQueryKey(reportUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appReportsSalesRetrieve>>> = ({ signal }) => appReportsSalesRetrieve(reportUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(reportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appReportsSalesRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AppReportsSalesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof appReportsSalesRetrieve>>>
export type AppReportsSalesRetrieveQueryError = unknown

export const useAppReportsSalesRetrieve = <TData = Awaited<ReturnType<typeof appReportsSalesRetrieve>>, TError = unknown>(
 reportUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appReportsSalesRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppReportsSalesRetrieveQueryOptions(reportUuid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Create a shared link for an entity
 */
export const appShareCreate = (
    sharedLinkResponse: NonReadonly<SharedLinkResponse>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<SharedLinkResponse>(
      {url: `/app/share/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sharedLinkResponse
    },
      options);
    }
  


export const getAppShareCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appShareCreate>>, TError,{data: NonReadonly<SharedLinkResponse>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof appShareCreate>>, TError,{data: NonReadonly<SharedLinkResponse>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appShareCreate>>, {data: NonReadonly<SharedLinkResponse>}> = (props) => {
          const {data} = props ?? {};

          return  appShareCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AppShareCreateMutationResult = NonNullable<Awaited<ReturnType<typeof appShareCreate>>>
    export type AppShareCreateMutationBody = NonReadonly<SharedLinkResponse>
    export type AppShareCreateMutationError = unknown

    export const useAppShareCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appShareCreate>>, TError,{data: NonReadonly<SharedLinkResponse>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof appShareCreate>>,
        TError,
        {data: NonReadonly<SharedLinkResponse>},
        TContext
      > => {

      const mutationOptions = getAppShareCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Verify a shared link by its UUID (GET) or delete the shared link (DELETE).
 */
export const appShareRetrieve = (
    uuid: string,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<SharedLinkVerifyResponse>(
      {url: `/app/share/${uuid}/`, method: 'GET', signal
    },
      options);
    }
  

export const getAppShareRetrieveQueryKey = (uuid: string,) => {
    return [`/app/share/${uuid}/`] as const;
    }

    
export const getAppShareRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof appShareRetrieve>>, TError = unknown>(uuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appShareRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppShareRetrieveQueryKey(uuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appShareRetrieve>>> = ({ signal }) => appShareRetrieve(uuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(uuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof appShareRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AppShareRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof appShareRetrieve>>>
export type AppShareRetrieveInfiniteQueryError = unknown

export const useAppShareRetrieveInfinite = <TData = Awaited<ReturnType<typeof appShareRetrieve>>, TError = unknown>(
 uuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appShareRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppShareRetrieveInfiniteQueryOptions(uuid,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAppShareRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof appShareRetrieve>>, TError = unknown>(uuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appShareRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppShareRetrieveQueryKey(uuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appShareRetrieve>>> = ({ signal }) => appShareRetrieve(uuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(uuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appShareRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AppShareRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof appShareRetrieve>>>
export type AppShareRetrieveQueryError = unknown

export const useAppShareRetrieve = <TData = Awaited<ReturnType<typeof appShareRetrieve>>, TError = unknown>(
 uuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appShareRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppShareRetrieveQueryOptions(uuid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Verify a shared link by its UUID (GET) or delete the shared link (DELETE).
 */
export const appShareDestroy = (
    uuid: string,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<void>(
      {url: `/app/share/${uuid}/`, method: 'DELETE'
    },
      options);
    }
  


export const getAppShareDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appShareDestroy>>, TError,{uuid: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof appShareDestroy>>, TError,{uuid: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appShareDestroy>>, {uuid: string}> = (props) => {
          const {uuid} = props ?? {};

          return  appShareDestroy(uuid,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AppShareDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof appShareDestroy>>>
    
    export type AppShareDestroyMutationError = unknown

    export const useAppShareDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appShareDestroy>>, TError,{uuid: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof appShareDestroy>>,
        TError,
        {uuid: string},
        TContext
      > => {

      const mutationOptions = getAppShareDestroyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const appShareResultCollectionRetrieve = (
    uuid: string,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<CollectionDetail>(
      {url: `/app/share/${uuid}/result/collection`, method: 'GET', signal
    },
      options);
    }
  

export const getAppShareResultCollectionRetrieveQueryKey = (uuid: string,) => {
    return [`/app/share/${uuid}/result/collection`] as const;
    }

    
export const getAppShareResultCollectionRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof appShareResultCollectionRetrieve>>, TError = unknown>(uuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appShareResultCollectionRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppShareResultCollectionRetrieveQueryKey(uuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appShareResultCollectionRetrieve>>> = ({ signal }) => appShareResultCollectionRetrieve(uuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(uuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof appShareResultCollectionRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AppShareResultCollectionRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof appShareResultCollectionRetrieve>>>
export type AppShareResultCollectionRetrieveInfiniteQueryError = unknown

export const useAppShareResultCollectionRetrieveInfinite = <TData = Awaited<ReturnType<typeof appShareResultCollectionRetrieve>>, TError = unknown>(
 uuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appShareResultCollectionRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppShareResultCollectionRetrieveInfiniteQueryOptions(uuid,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAppShareResultCollectionRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof appShareResultCollectionRetrieve>>, TError = unknown>(uuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appShareResultCollectionRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppShareResultCollectionRetrieveQueryKey(uuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appShareResultCollectionRetrieve>>> = ({ signal }) => appShareResultCollectionRetrieve(uuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(uuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appShareResultCollectionRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AppShareResultCollectionRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof appShareResultCollectionRetrieve>>>
export type AppShareResultCollectionRetrieveQueryError = unknown

export const useAppShareResultCollectionRetrieve = <TData = Awaited<ReturnType<typeof appShareResultCollectionRetrieve>>, TError = unknown>(
 uuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appShareResultCollectionRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppShareResultCollectionRetrieveQueryOptions(uuid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const appShareResultProductAssessmentRetrieve = (
    uuid: string,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<ProductResult>(
      {url: `/app/share/${uuid}/result/product-assessment`, method: 'GET', signal
    },
      options);
    }
  

export const getAppShareResultProductAssessmentRetrieveQueryKey = (uuid: string,) => {
    return [`/app/share/${uuid}/result/product-assessment`] as const;
    }

    
export const getAppShareResultProductAssessmentRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof appShareResultProductAssessmentRetrieve>>, TError = unknown>(uuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appShareResultProductAssessmentRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppShareResultProductAssessmentRetrieveQueryKey(uuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appShareResultProductAssessmentRetrieve>>> = ({ signal }) => appShareResultProductAssessmentRetrieve(uuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(uuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof appShareResultProductAssessmentRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AppShareResultProductAssessmentRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof appShareResultProductAssessmentRetrieve>>>
export type AppShareResultProductAssessmentRetrieveInfiniteQueryError = unknown

export const useAppShareResultProductAssessmentRetrieveInfinite = <TData = Awaited<ReturnType<typeof appShareResultProductAssessmentRetrieve>>, TError = unknown>(
 uuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appShareResultProductAssessmentRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppShareResultProductAssessmentRetrieveInfiniteQueryOptions(uuid,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAppShareResultProductAssessmentRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof appShareResultProductAssessmentRetrieve>>, TError = unknown>(uuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appShareResultProductAssessmentRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppShareResultProductAssessmentRetrieveQueryKey(uuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appShareResultProductAssessmentRetrieve>>> = ({ signal }) => appShareResultProductAssessmentRetrieve(uuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(uuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appShareResultProductAssessmentRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AppShareResultProductAssessmentRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof appShareResultProductAssessmentRetrieve>>>
export type AppShareResultProductAssessmentRetrieveQueryError = unknown

export const useAppShareResultProductAssessmentRetrieve = <TData = Awaited<ReturnType<typeof appShareResultProductAssessmentRetrieve>>, TError = unknown>(
 uuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appShareResultProductAssessmentRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppShareResultProductAssessmentRetrieveQueryOptions(uuid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const appShareResultProductionReportRetrieve = (
    uuid: string,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<ReportProductDetail>(
      {url: `/app/share/${uuid}/result/production-report`, method: 'GET', signal
    },
      options);
    }
  

export const getAppShareResultProductionReportRetrieveQueryKey = (uuid: string,) => {
    return [`/app/share/${uuid}/result/production-report`] as const;
    }

    
export const getAppShareResultProductionReportRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof appShareResultProductionReportRetrieve>>, TError = unknown>(uuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appShareResultProductionReportRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppShareResultProductionReportRetrieveQueryKey(uuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appShareResultProductionReportRetrieve>>> = ({ signal }) => appShareResultProductionReportRetrieve(uuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(uuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof appShareResultProductionReportRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AppShareResultProductionReportRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof appShareResultProductionReportRetrieve>>>
export type AppShareResultProductionReportRetrieveInfiniteQueryError = unknown

export const useAppShareResultProductionReportRetrieveInfinite = <TData = Awaited<ReturnType<typeof appShareResultProductionReportRetrieve>>, TError = unknown>(
 uuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appShareResultProductionReportRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppShareResultProductionReportRetrieveInfiniteQueryOptions(uuid,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAppShareResultProductionReportRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof appShareResultProductionReportRetrieve>>, TError = unknown>(uuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appShareResultProductionReportRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppShareResultProductionReportRetrieveQueryKey(uuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appShareResultProductionReportRetrieve>>> = ({ signal }) => appShareResultProductionReportRetrieve(uuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(uuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appShareResultProductionReportRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AppShareResultProductionReportRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof appShareResultProductionReportRetrieve>>>
export type AppShareResultProductionReportRetrieveQueryError = unknown

export const useAppShareResultProductionReportRetrieve = <TData = Awaited<ReturnType<typeof appShareResultProductionReportRetrieve>>, TError = unknown>(
 uuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appShareResultProductionReportRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppShareResultProductionReportRetrieveQueryOptions(uuid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const appShareResultPurchasingReportRetrieve = (
    uuid: string,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<ReportOrganizationFoodDetail>(
      {url: `/app/share/${uuid}/result/purchasing-report`, method: 'GET', signal
    },
      options);
    }
  

export const getAppShareResultPurchasingReportRetrieveQueryKey = (uuid: string,) => {
    return [`/app/share/${uuid}/result/purchasing-report`] as const;
    }

    
export const getAppShareResultPurchasingReportRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof appShareResultPurchasingReportRetrieve>>, TError = unknown>(uuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appShareResultPurchasingReportRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppShareResultPurchasingReportRetrieveQueryKey(uuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appShareResultPurchasingReportRetrieve>>> = ({ signal }) => appShareResultPurchasingReportRetrieve(uuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(uuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof appShareResultPurchasingReportRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AppShareResultPurchasingReportRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof appShareResultPurchasingReportRetrieve>>>
export type AppShareResultPurchasingReportRetrieveInfiniteQueryError = unknown

export const useAppShareResultPurchasingReportRetrieveInfinite = <TData = Awaited<ReturnType<typeof appShareResultPurchasingReportRetrieve>>, TError = unknown>(
 uuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appShareResultPurchasingReportRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppShareResultPurchasingReportRetrieveInfiniteQueryOptions(uuid,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAppShareResultPurchasingReportRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof appShareResultPurchasingReportRetrieve>>, TError = unknown>(uuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appShareResultPurchasingReportRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppShareResultPurchasingReportRetrieveQueryKey(uuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appShareResultPurchasingReportRetrieve>>> = ({ signal }) => appShareResultPurchasingReportRetrieve(uuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(uuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appShareResultPurchasingReportRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AppShareResultPurchasingReportRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof appShareResultPurchasingReportRetrieve>>>
export type AppShareResultPurchasingReportRetrieveQueryError = unknown

export const useAppShareResultPurchasingReportRetrieve = <TData = Awaited<ReturnType<typeof appShareResultPurchasingReportRetrieve>>, TError = unknown>(
 uuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appShareResultPurchasingReportRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppShareResultPurchasingReportRetrieveQueryOptions(uuid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const appShareResultSalesReportRetrieve = (
    uuid: string,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<ReportProductDetail>(
      {url: `/app/share/${uuid}/result/sales-report`, method: 'GET', signal
    },
      options);
    }
  

export const getAppShareResultSalesReportRetrieveQueryKey = (uuid: string,) => {
    return [`/app/share/${uuid}/result/sales-report`] as const;
    }

    
export const getAppShareResultSalesReportRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof appShareResultSalesReportRetrieve>>, TError = unknown>(uuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appShareResultSalesReportRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppShareResultSalesReportRetrieveQueryKey(uuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appShareResultSalesReportRetrieve>>> = ({ signal }) => appShareResultSalesReportRetrieve(uuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(uuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof appShareResultSalesReportRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AppShareResultSalesReportRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof appShareResultSalesReportRetrieve>>>
export type AppShareResultSalesReportRetrieveInfiniteQueryError = unknown

export const useAppShareResultSalesReportRetrieveInfinite = <TData = Awaited<ReturnType<typeof appShareResultSalesReportRetrieve>>, TError = unknown>(
 uuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appShareResultSalesReportRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppShareResultSalesReportRetrieveInfiniteQueryOptions(uuid,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAppShareResultSalesReportRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof appShareResultSalesReportRetrieve>>, TError = unknown>(uuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appShareResultSalesReportRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppShareResultSalesReportRetrieveQueryKey(uuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appShareResultSalesReportRetrieve>>> = ({ signal }) => appShareResultSalesReportRetrieve(uuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(uuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appShareResultSalesReportRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AppShareResultSalesReportRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof appShareResultSalesReportRetrieve>>>
export type AppShareResultSalesReportRetrieveQueryError = unknown

export const useAppShareResultSalesReportRetrieve = <TData = Awaited<ReturnType<typeof appShareResultSalesReportRetrieve>>, TError = unknown>(
 uuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appShareResultSalesReportRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppShareResultSalesReportRetrieveQueryOptions(uuid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const appShareQueryRetrieve = (
    params?: AppShareQueryRetrieveParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<SharedLinkResponse>(
      {url: `/app/share/query/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getAppShareQueryRetrieveQueryKey = (params?: AppShareQueryRetrieveParams,) => {
    return [`/app/share/query/`, ...(params ? [params]: [])] as const;
    }

    
export const getAppShareQueryRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof appShareQueryRetrieve>>, TError = unknown>(params?: AppShareQueryRetrieveParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appShareQueryRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppShareQueryRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appShareQueryRetrieve>>> = ({ signal, pageParam }) => appShareQueryRetrieve({...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof appShareQueryRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AppShareQueryRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof appShareQueryRetrieve>>>
export type AppShareQueryRetrieveInfiniteQueryError = unknown

export const useAppShareQueryRetrieveInfinite = <TData = Awaited<ReturnType<typeof appShareQueryRetrieve>>, TError = unknown>(
 params?: AppShareQueryRetrieveParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appShareQueryRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppShareQueryRetrieveInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAppShareQueryRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof appShareQueryRetrieve>>, TError = unknown>(params?: AppShareQueryRetrieveParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appShareQueryRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppShareQueryRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appShareQueryRetrieve>>> = ({ signal }) => appShareQueryRetrieve(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appShareQueryRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AppShareQueryRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof appShareQueryRetrieve>>>
export type AppShareQueryRetrieveQueryError = unknown

export const useAppShareQueryRetrieve = <TData = Awaited<ReturnType<typeof appShareQueryRetrieve>>, TError = unknown>(
 params?: AppShareQueryRetrieveParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appShareQueryRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppShareQueryRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Takes a refresh type JSON web token and returns an access type JSON web
token if the refresh token is valid.
 */
export const appTokenRefresh2Create = (
    tokenRefresh: NonReadonly<TokenRefresh>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<unknown>(
      {url: `/app/token/refresh2/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: tokenRefresh
    },
      options);
    }
  


export const getAppTokenRefresh2CreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appTokenRefresh2Create>>, TError,{data: NonReadonly<TokenRefresh>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof appTokenRefresh2Create>>, TError,{data: NonReadonly<TokenRefresh>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appTokenRefresh2Create>>, {data: NonReadonly<TokenRefresh>}> = (props) => {
          const {data} = props ?? {};

          return  appTokenRefresh2Create(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AppTokenRefresh2CreateMutationResult = NonNullable<Awaited<ReturnType<typeof appTokenRefresh2Create>>>
    export type AppTokenRefresh2CreateMutationBody = NonReadonly<TokenRefresh>
    export type AppTokenRefresh2CreateMutationError = unknown

    export const useAppTokenRefresh2Create = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appTokenRefresh2Create>>, TError,{data: NonReadonly<TokenRefresh>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof appTokenRefresh2Create>>,
        TError,
        {data: NonReadonly<TokenRefresh>},
        TContext
      > => {

      const mutationOptions = getAppTokenRefresh2CreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Takes a token and indicates if it is valid.  This view provides no
information about a token's fitness for a particular use.
 */
export const appTokenVerifyCreate = (
    tokenVerify: TokenVerify,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<unknown>(
      {url: `/app/token/verify/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: tokenVerify
    },
      options);
    }
  


export const getAppTokenVerifyCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appTokenVerifyCreate>>, TError,{data: TokenVerify}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof appTokenVerifyCreate>>, TError,{data: TokenVerify}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appTokenVerifyCreate>>, {data: TokenVerify}> = (props) => {
          const {data} = props ?? {};

          return  appTokenVerifyCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AppTokenVerifyCreateMutationResult = NonNullable<Awaited<ReturnType<typeof appTokenVerifyCreate>>>
    export type AppTokenVerifyCreateMutationBody = TokenVerify
    export type AppTokenVerifyCreateMutationError = unknown

    export const useAppTokenVerifyCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appTokenVerifyCreate>>, TError,{data: TokenVerify}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof appTokenVerifyCreate>>,
        TError,
        {data: TokenVerify},
        TContext
      > => {

      const mutationOptions = getAppTokenVerifyCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const appTransportList = (
    
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<JourneyGroupList[]>(
      {url: `/app/transport/`, method: 'GET', signal
    },
      options);
    }
  

export const getAppTransportListQueryKey = () => {
    return [`/app/transport/`] as const;
    }

    
export const getAppTransportListInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof appTransportList>>, TError = unknown>( options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appTransportList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppTransportListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appTransportList>>> = ({ signal }) => appTransportList(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof appTransportList>>, TError, TData> & { queryKey: QueryKey }
}

export type AppTransportListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof appTransportList>>>
export type AppTransportListInfiniteQueryError = unknown

export const useAppTransportListInfinite = <TData = Awaited<ReturnType<typeof appTransportList>>, TError = unknown>(
  options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appTransportList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppTransportListInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAppTransportListQueryOptions = <TData = Awaited<ReturnType<typeof appTransportList>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appTransportList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppTransportListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appTransportList>>> = ({ signal }) => appTransportList(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appTransportList>>, TError, TData> & { queryKey: QueryKey }
}

export type AppTransportListQueryResult = NonNullable<Awaited<ReturnType<typeof appTransportList>>>
export type AppTransportListQueryError = unknown

export const useAppTransportList = <TData = Awaited<ReturnType<typeof appTransportList>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appTransportList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppTransportListQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const appTransportCreate = (
    journeyGroupCreate: NonReadonly<JourneyGroupCreate>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<JourneyGroupCreate>(
      {url: `/app/transport/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: journeyGroupCreate
    },
      options);
    }
  


export const getAppTransportCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appTransportCreate>>, TError,{data: NonReadonly<JourneyGroupCreate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof appTransportCreate>>, TError,{data: NonReadonly<JourneyGroupCreate>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appTransportCreate>>, {data: NonReadonly<JourneyGroupCreate>}> = (props) => {
          const {data} = props ?? {};

          return  appTransportCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AppTransportCreateMutationResult = NonNullable<Awaited<ReturnType<typeof appTransportCreate>>>
    export type AppTransportCreateMutationBody = NonReadonly<JourneyGroupCreate>
    export type AppTransportCreateMutationError = unknown

    export const useAppTransportCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appTransportCreate>>, TError,{data: NonReadonly<JourneyGroupCreate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof appTransportCreate>>,
        TError,
        {data: NonReadonly<JourneyGroupCreate>},
        TContext
      > => {

      const mutationOptions = getAppTransportCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const appTransportRetrieve = (
    transportTypeUuid: string,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<JourneyGroupList>(
      {url: `/app/transport/${transportTypeUuid}/`, method: 'GET', signal
    },
      options);
    }
  

export const getAppTransportRetrieveQueryKey = (transportTypeUuid: string,) => {
    return [`/app/transport/${transportTypeUuid}/`] as const;
    }

    
export const getAppTransportRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof appTransportRetrieve>>, TError = unknown>(transportTypeUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appTransportRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppTransportRetrieveQueryKey(transportTypeUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appTransportRetrieve>>> = ({ signal }) => appTransportRetrieve(transportTypeUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(transportTypeUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof appTransportRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AppTransportRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof appTransportRetrieve>>>
export type AppTransportRetrieveInfiniteQueryError = unknown

export const useAppTransportRetrieveInfinite = <TData = Awaited<ReturnType<typeof appTransportRetrieve>>, TError = unknown>(
 transportTypeUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appTransportRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppTransportRetrieveInfiniteQueryOptions(transportTypeUuid,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAppTransportRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof appTransportRetrieve>>, TError = unknown>(transportTypeUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appTransportRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppTransportRetrieveQueryKey(transportTypeUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appTransportRetrieve>>> = ({ signal }) => appTransportRetrieve(transportTypeUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(transportTypeUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appTransportRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AppTransportRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof appTransportRetrieve>>>
export type AppTransportRetrieveQueryError = unknown

export const useAppTransportRetrieve = <TData = Awaited<ReturnType<typeof appTransportRetrieve>>, TError = unknown>(
 transportTypeUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appTransportRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppTransportRetrieveQueryOptions(transportTypeUuid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const appTransportUpdate = (
    transportTypeUuid: string,
    journeyGroupUpdate: NonReadonly<JourneyGroupUpdate>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<JourneyGroupUpdate>(
      {url: `/app/transport/${transportTypeUuid}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: journeyGroupUpdate
    },
      options);
    }
  


export const getAppTransportUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appTransportUpdate>>, TError,{transportTypeUuid: string;data: NonReadonly<JourneyGroupUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof appTransportUpdate>>, TError,{transportTypeUuid: string;data: NonReadonly<JourneyGroupUpdate>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appTransportUpdate>>, {transportTypeUuid: string;data: NonReadonly<JourneyGroupUpdate>}> = (props) => {
          const {transportTypeUuid,data} = props ?? {};

          return  appTransportUpdate(transportTypeUuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AppTransportUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof appTransportUpdate>>>
    export type AppTransportUpdateMutationBody = NonReadonly<JourneyGroupUpdate>
    export type AppTransportUpdateMutationError = unknown

    export const useAppTransportUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appTransportUpdate>>, TError,{transportTypeUuid: string;data: NonReadonly<JourneyGroupUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof appTransportUpdate>>,
        TError,
        {transportTypeUuid: string;data: NonReadonly<JourneyGroupUpdate>},
        TContext
      > => {

      const mutationOptions = getAppTransportUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const appTransportPartialUpdate = (
    transportTypeUuid: string,
    patchedJourneyGroupUpdate: NonReadonly<PatchedJourneyGroupUpdate>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<JourneyGroupUpdate>(
      {url: `/app/transport/${transportTypeUuid}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedJourneyGroupUpdate
    },
      options);
    }
  


export const getAppTransportPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appTransportPartialUpdate>>, TError,{transportTypeUuid: string;data: NonReadonly<PatchedJourneyGroupUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof appTransportPartialUpdate>>, TError,{transportTypeUuid: string;data: NonReadonly<PatchedJourneyGroupUpdate>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appTransportPartialUpdate>>, {transportTypeUuid: string;data: NonReadonly<PatchedJourneyGroupUpdate>}> = (props) => {
          const {transportTypeUuid,data} = props ?? {};

          return  appTransportPartialUpdate(transportTypeUuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AppTransportPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof appTransportPartialUpdate>>>
    export type AppTransportPartialUpdateMutationBody = NonReadonly<PatchedJourneyGroupUpdate>
    export type AppTransportPartialUpdateMutationError = unknown

    export const useAppTransportPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appTransportPartialUpdate>>, TError,{transportTypeUuid: string;data: NonReadonly<PatchedJourneyGroupUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof appTransportPartialUpdate>>,
        TError,
        {transportTypeUuid: string;data: NonReadonly<PatchedJourneyGroupUpdate>},
        TContext
      > => {

      const mutationOptions = getAppTransportPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const appTransportDestroy = (
    transportTypeUuid: string,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<void>(
      {url: `/app/transport/${transportTypeUuid}/`, method: 'DELETE'
    },
      options);
    }
  


export const getAppTransportDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appTransportDestroy>>, TError,{transportTypeUuid: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof appTransportDestroy>>, TError,{transportTypeUuid: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appTransportDestroy>>, {transportTypeUuid: string}> = (props) => {
          const {transportTypeUuid} = props ?? {};

          return  appTransportDestroy(transportTypeUuid,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AppTransportDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof appTransportDestroy>>>
    
    export type AppTransportDestroyMutationError = unknown

    export const useAppTransportDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appTransportDestroy>>, TError,{transportTypeUuid: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof appTransportDestroy>>,
        TError,
        {transportTypeUuid: string},
        TContext
      > => {

      const mutationOptions = getAppTransportDestroyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const appTransportFileRetrieve = (
    transportTypeUuid: string,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<TransportTypeFileRetrieve>(
      {url: `/app/transport/${transportTypeUuid}/file/`, method: 'GET', signal
    },
      options);
    }
  

export const getAppTransportFileRetrieveQueryKey = (transportTypeUuid: string,) => {
    return [`/app/transport/${transportTypeUuid}/file/`] as const;
    }

    
export const getAppTransportFileRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof appTransportFileRetrieve>>, TError = unknown>(transportTypeUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appTransportFileRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppTransportFileRetrieveQueryKey(transportTypeUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appTransportFileRetrieve>>> = ({ signal }) => appTransportFileRetrieve(transportTypeUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(transportTypeUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof appTransportFileRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AppTransportFileRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof appTransportFileRetrieve>>>
export type AppTransportFileRetrieveInfiniteQueryError = unknown

export const useAppTransportFileRetrieveInfinite = <TData = Awaited<ReturnType<typeof appTransportFileRetrieve>>, TError = unknown>(
 transportTypeUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appTransportFileRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppTransportFileRetrieveInfiniteQueryOptions(transportTypeUuid,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAppTransportFileRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof appTransportFileRetrieve>>, TError = unknown>(transportTypeUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appTransportFileRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppTransportFileRetrieveQueryKey(transportTypeUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appTransportFileRetrieve>>> = ({ signal }) => appTransportFileRetrieve(transportTypeUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(transportTypeUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appTransportFileRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AppTransportFileRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof appTransportFileRetrieve>>>
export type AppTransportFileRetrieveQueryError = unknown

export const useAppTransportFileRetrieve = <TData = Awaited<ReturnType<typeof appTransportFileRetrieve>>, TError = unknown>(
 transportTypeUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appTransportFileRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppTransportFileRetrieveQueryOptions(transportTypeUuid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const appTransportFileCreate = (
    transportTypeUuid: string,
    transportTypeFileUuid: string,
    transportTypeFileFinish: TransportTypeFileFinish,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<TransportTypeFileFinish>(
      {url: `/app/transport/${transportTypeUuid}/file/${transportTypeFileUuid}/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: transportTypeFileFinish
    },
      options);
    }
  


export const getAppTransportFileCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appTransportFileCreate>>, TError,{transportTypeUuid: string;transportTypeFileUuid: string;data: TransportTypeFileFinish}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof appTransportFileCreate>>, TError,{transportTypeUuid: string;transportTypeFileUuid: string;data: TransportTypeFileFinish}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appTransportFileCreate>>, {transportTypeUuid: string;transportTypeFileUuid: string;data: TransportTypeFileFinish}> = (props) => {
          const {transportTypeUuid,transportTypeFileUuid,data} = props ?? {};

          return  appTransportFileCreate(transportTypeUuid,transportTypeFileUuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AppTransportFileCreateMutationResult = NonNullable<Awaited<ReturnType<typeof appTransportFileCreate>>>
    export type AppTransportFileCreateMutationBody = TransportTypeFileFinish
    export type AppTransportFileCreateMutationError = unknown

    export const useAppTransportFileCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appTransportFileCreate>>, TError,{transportTypeUuid: string;transportTypeFileUuid: string;data: TransportTypeFileFinish}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof appTransportFileCreate>>,
        TError,
        {transportTypeUuid: string;transportTypeFileUuid: string;data: TransportTypeFileFinish},
        TContext
      > => {

      const mutationOptions = getAppTransportFileCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const appUnitsList = (
    
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<Unit[]>(
      {url: `/app/units/`, method: 'GET', signal
    },
      options);
    }
  

export const getAppUnitsListQueryKey = () => {
    return [`/app/units/`] as const;
    }

    
export const getAppUnitsListInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof appUnitsList>>, TError = unknown>( options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appUnitsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppUnitsListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appUnitsList>>> = ({ signal }) => appUnitsList(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof appUnitsList>>, TError, TData> & { queryKey: QueryKey }
}

export type AppUnitsListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof appUnitsList>>>
export type AppUnitsListInfiniteQueryError = unknown

export const useAppUnitsListInfinite = <TData = Awaited<ReturnType<typeof appUnitsList>>, TError = unknown>(
  options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appUnitsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppUnitsListInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAppUnitsListQueryOptions = <TData = Awaited<ReturnType<typeof appUnitsList>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appUnitsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppUnitsListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appUnitsList>>> = ({ signal }) => appUnitsList(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appUnitsList>>, TError, TData> & { queryKey: QueryKey }
}

export type AppUnitsListQueryResult = NonNullable<Awaited<ReturnType<typeof appUnitsList>>>
export type AppUnitsListQueryError = unknown

export const useAppUnitsList = <TData = Awaited<ReturnType<typeof appUnitsList>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appUnitsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppUnitsListQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



